import { KYMW0400OutputModel } from '../../kymw04/kymw0400/vo/kymw0400-output.model';
import { Component, ViewChild, ViewEncapsulation, OnInit, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
import { CellRange, CellType, FlexGrid } from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';
import { EventArgs } from '@grapecity/wijmo';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0400Component } from '../../kymw04/kymw0400/kymw0400.component';
import { KYMW0400InputModel } from '../../kymw04/kymw0400/vo/kymw0400-input.model';
import { CodeComboBoxComponent } from '../../kymw02/combo-box/code-combo-box/code-combo-box.component';
import { FileDownloadConfirmService } from '../../kymw02/file-download-confirm/file-download-confirm.service';
import { KYMW0C00Model } from './kymw0c00.model';
import { KYMW0E00Component } from '../../kymw0e/kymw0e00/kymw0e00.component';
import { KYMW0C00InputModel } from './vo/kymw0c00-input.model';
import { KYMW0C00OutputModel, ImageInfo } from './vo/kymw0c00-output.model';
import { KYMW0E00InputModel } from '../../kymw0e/kymw0e00/vo/kymw0e00-input.model';
import { UpdateImageInfoModel } from './vo/update-image-info.model';
import { UpdateImageInfoDetailModel } from './vo/update-image-info-detail.model';
import { GetSupplierNameService } from './api-services/get-supplier-name.service';
import { GetPCodeDataService } from './api-services/get-pcode-data.service';
import { GetImageGroupInfoService } from './api-services/get-image-group-info.service';
import { GetImageNameService } from './api-services/get-image-name.service';
import { GetSampleOrderingOutputService } from './api-services/get-sample-ordering-output.service';
import { GetImageTypeLimitService } from './api-services/get-image-type-limit.service';
import { UpdateImageInfoService } from './api-services/update-image-info.service';
import { OrderCodeTextInputComponent } from '../../kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { ImageInstructListRowModel } from './vo/image-instruct-list-row.model';
import { KYMW0E00OutputModel } from '../../kymw0e/kymw0e00/vo/kymw0e00-output.model';
import * as wjcCore from '@grapecity/wijmo';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { CommonSetting } from '../../kymw00/common-setting';
import { FileAccept, FileUploadService } from '../../kymw02/file-upload/file-upload.service';
import { ReferenceImageFileUploadService } from './api-services/reference-image-file-upload.service';
import { PlessViewUtils } from 'src/app/shared/utils/pless-view-utils.service';
import { ReferenceImageList } from './vo/reference-image-list.model';
import { TextInputComponent } from 'src/app/commons/kymw02/text-input/text-input/text-input.component';
import { ReferenceImageDeleteList } from './vo/reference-image-delete-list.model';
import { WjInputDate } from '@grapecity/wijmo.angular2.input';
import { CanDeactivateType } from '../../../shared/utils/leave-confirm.guard';
import { Subject } from 'rxjs';

/**
 * 画像作成指示画面を管理するクラス
 *
 * @export KYMW0C00Component
 * @class KYMW0C00Component
 */
@Component({
  selector: 'app-kymw0c00',
  templateUrl: 'kymw0c00.component.html',
  styleUrls: ['kymw0c00.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0C00Component extends PlessViewHelperSub implements OnInit, AfterViewInit {
  @ViewChild('dtg_ImageInstructList', { static: false }) dtg_ImageInstructList: FlexGrid;
  @ViewChild('cmb_ImageType', { static: false }) cmb_ImageType: CodeComboBoxComponent;
  @ViewChild('cmb_ImageBelongID', { static: false }) cmb_ImageBelongID: CodeComboBoxComponent;
  @ViewChild('cmb_ProcessInstruct', { static: false }) cmb_ProcessInstruct: CodeComboBoxComponent;
  @ViewChild('cmb_CookingDiv', { static: false }) cmb_CookingDiv: CodeComboBoxComponent;
  @ViewChild('cmb_PhotoContentsDiv', { static: false }) cmb_PhotoContentsDiv: CodeComboBoxComponent;
  @ViewChild('cmb_EventID', { static: false }) cmb_EventID: CodeComboBoxComponent;
  @ViewChild('cmb_ColorChange', { static: false })cmb_ColorChange: CodeComboBoxComponent;
  @ViewChild('txti_StartOrderCode', { static: false }) private txti_StartOrderCode: OrderCodeTextInputComponent;
  @ViewChild('txti_EndOrderCode', { static: false }) private txti_EndOrderCode: OrderCodeTextInputComponent;
  @ViewChild('txti_ShootingPackageText', { static: false }) private txti_ShootingPackageText: TextInputComponent;
  @ViewChild('txti_AlignmentHorizontal', { static: false }) private txti_AlignmentHorizontal: TextInputComponent;
  @ViewChild('txti_AlignmentVertical', { static: false }) private txti_AlignmentVertical: TextInputComponent;
  @ViewChild('txti_QtyCookNecessaryNum', { static: false }) private txti_QtyCookNecessaryNum: TextInputComponent;
  @ViewChild('txti_QtyCookNecessaryVesselNum', { static: false }) private txti_QtyCookNecessaryVesselNum: TextInputComponent;
  @ViewChild('txti_QtyCookUnnecessaryNum', { static: false }) private txti_QtyCookUnnecessaryNum: TextInputComponent;
  @ViewChild('txti_QtyCookUnnecessaryVesselNum', { static: false }) private txti_QtyCookUnnecessaryVesselNum: TextInputComponent;
  @ViewChild('txti_MultipleCode', { static: false }) private txti_MultipleCode: TextInputComponent;
  @ViewChild('dtf_PhotoSchedule', {static: false }) private dtf_PhotoSchedule: WjInputDate;

  iconQuestion = faQuestionCircle;

  /** 編集済みかをチェックするカウンタ */
  public editFlag: boolean = <boolean>false;

  // 親画面からの連携値
  public inputParam: KYMW0C00InputModel;

  // 親画面への連携用
  setKYMW0C00Parameter: Function;

  /** KYMW0C00画面用モデル */
  kymw0C00Model: KYMW0C00Model = new KYMW0C00Model();

  /** コンテキストメニュー */
  private contextMenu: Menu;
  private fileContextMenu: Menu;

  // 選択されたファイル
  private fileSelectIndex:number = null;
  // 選択ファイル
  private selectedFile: File;

  private forbiddenCharactersRegex = /[\x00-\x2F\x3A-\x40\x5B-\x5E\x60\x7B-\x7F\x7E\x80-\xFF\u0192\u0131\u2017\u2500-\u259F\u25A0\u3000]/;

  public dispDialog = false;

  // 参考資料アップロード 許容する拡張子
  private extensions = ['png', 'pdf', 'jpg', 'jpeg', 'xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xls', 'xlt', 'xls', 'xml', 'xlam', 'xlw', 'xlr'];

  // Excelアイコン表示
  private excelExtensions = ['xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xls', 'xlt', 'xls', 'xml', 'xlam', 'xlw', 'xlr'];

  /**
   *Creates an instance of KYMW0C00Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0C00Component
   */
  constructor(
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    public dialogService: PlessDialogServiceSub,
    private getImageGroupInfoService: GetImageGroupInfoService,
    private getImageNameService: GetImageNameService,
    private getImageTypeLimitService: GetImageTypeLimitService,
    private getPCodeDataService: GetPCodeDataService,
    private getSampleOrderingOutputService: GetSampleOrderingOutputService,
    private getSupplierNameService: GetSupplierNameService,
    private updateImageInfoService: UpdateImageInfoService,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private fileUploadService: FileUploadService,
    private referenceImageFileUploadService: ReferenceImageFileUploadService,
    private render: Renderer2,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0C00Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0C00';

    this.kymw0C00Model.kymw0C00Component = this;

    // 画面初期処理
    this.kymw0C00Model.clearImageInfoHead();
    this.kymw0C00Model.clearImageInfoDetail();
    this.kymw0C00Model.btnOutputEnabled = false;
    this.kymw0C00Model.endOrderCodeEnabled = false;

    // 画像種別単位の登録上限件数を取得するイベント発行
    this.getImageTypeLimitService.execute(this.kymw0C00Model, (serverData: any) => {
      this.kymw0C00Model.getImageTypeLimit(serverData);
    });

    // ページテンプレートリスト取得取得処理を起動
    if (this.inputParam == null) {
      // 登録モード
      this.kymw0C00Model.editMode = '1';
      this.inputParam = new KYMW0C00InputModel();
    } else if (!PlessViewUtilsSub.isEmpty(this.inputParam.ImageID)) {
      this.eventSendGetImageGroupInfoEvent(this.inputParam.ImageID);
      // 編集モード
      this.kymw0C00Model.editMode = '2';
    } else {
      // 登録モード
      this.kymw0C00Model.editMode = '1';
      if (!PlessViewUtilsSub.isEmpty(this.inputParam.pcode)) {
        this.eventSendGetPCodeInfoEvent(this.inputParam.pcode);
      }
    }

    // 権限取得
    if (this.getFuncPermission('KYMW1700') === '1') {
      this.kymw0C00Model.funcPermissionViewer = true;
      this.kymw0C00Model.startOrderCodeEnabled = false;
      this.kymw0C00Model.referenceImagePhotoContentsDivEnabled = false;
      this.kymw0C00Model.btnNewEnabled = false;
      this.kymw0C00Model.btnNewImageEnabled = false;
      this.kymw0C00Model.btnUpdateEnabled = false;
      this.kymw0C00Model.btnSettingEnabled = false;
    }
  }

  ngAfterViewInit() {
    this.txti_MultipleCode.input.nativeElement.setAttribute('placeholder', '複数コード登録の画像ファイル名を入力');

    // コンテキストメニュー設定
    this.setContextMenu();

    // 変更イベントリスナーの設定
    this.eventListenerSetting();

    // グリッドの初期選択行はなしとする
    this.dtg_ImageInstructList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_ImageInstructList.select(-1, -1);
    });
    // 画像作成指示リスト選択変更時イベントの設定
    setTimeout(() => {
      this.addEventImageInstructListCLICKHandler();
    });

    // メイン画面かダイアログ画面かでcssクラスを指定
    const contentArea = document.querySelector('app-kymw0c00 .contents-area');
    if(this.dispDialog) {
      contentArea.classList.add('dialog');
    } else {
      contentArea.classList.add('main');
    }
    this.txti_StartOrderCode.setFocus();
  }

  /**
   * グリッドのselectionChangedイベント追加
   */
  public addEventImageInstructListCLICKHandler(): void {
    this.dtg_ImageInstructList.selectionChanged.addHandler((e) => {
      this.eventImageInstructList_CLICKHandler(null, this.dtg_ImageInstructList)
    });
  }

  /**
   * グリッドのselectionChangedイベント削除
   */
  public removeEventImageInstructListCLICKHandler(): void {
    this.dtg_ImageInstructList.selectionChanged.removeAllHandlers();
  }

  /**
   * ソート実行前イベント
   * selectionChangedイベント削除して不要な画面更新を抑止
   */
  public eventSortingColumn_Handler(): void {
    this.removeEventImageInstructListCLICKHandler();
  }

  /**
   * ソート実行後イベント
   * ソート実行前イベントで削除したselectionChangedイベントを元に戻す
   */
  public eventSortedColumn_Handler(): void {
    this.addEventImageInstructListCLICKHandler();
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW0C00Component
   */
  public setInterfaceParam(param: KYMW0C00InputModel): void {
    this.inputParam = param;
    this.dispDialog = true;
  }

  /**
   * コンテキストメニューを追加
   */
  private setContextMenu(): void {
    this.contextMenu = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { caption: '行削除', cmd: 'rowDelete', enabled: true },
        { caption: '削除取消', cmd: 'rowDeleteCancel', enabled: true },
      ],
      command: this.getFormatMenuCommand(),
      itemClicked: () => {
        switch (this.contextMenu.selectedValue) {
          case 'rowDelete':
            this.eventDelete_CLICKHandler();
            break;
          case 'rowDeleteCancel':
            this.eventUnDelete_CLICKHandler();
            break;
        }
      }
    });
    this.dtg_ImageInstructList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {
        this.eventContextMenu_MENUSELECTHandler(e);
        // メニュー表示
        this.contextMenu.show(e);
      }
    });

    this.fileContextMenu = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { caption: '参考資料削除', cmd: 'fileDelete', enabled: true },
      ],
      command: this.getFormatMenuCommand(),
      itemClicked: () => {
        switch (this.fileContextMenu.selectedValue) {
          case 'fileDelete':
            this.eventFileDelete_CLICKHandler();
            break;
        }
      }
    });
  }

  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  public eventContextMenu_MENUSELECTHandler(e: any): void {
    const ht = this.dtg_ImageInstructList.hitTest(e.pageX, e.pageY);

    // コンテキストメニューの利用可能不可判断フラグ
    let contextMenuEnabledMode = Boolean(true);
    // グリッドのセル外または選択行がない場合はコンテキストメニューを非活性
    if (ht.cellType !== CellType.Cell || (PlessViewUtilsSub.isEmptyArray(this.dtg_ImageInstructList.selectedRows))) {
      contextMenuEnabledMode = false;
      // 画像変更のコンテキストメニューアイテムを探し出し、権限を設定する
      this.contextMenu.itemsSource.forEach((item: { enabled: boolean; caption: string; }) => {
        item.enabled = contextMenuEnabledMode;
      });
    } else {
      this.setDataGridContextMenuEnabled(this.contextMenu, this.dtg_ImageInstructList.selectedRows[0]);
    }

  }

  /**
   * 参考資料画像右クリック押下イベント
   * @param i インデックス
   */
  public eventFileList_ITEMCLICK(i: number): void {
    const selectElement = "referenceImage" + i
    if (document.getElementById(selectElement) != null) {
      document.getElementById(selectElement).addEventListener('contextmenu', (e: any) => {
        // イベントを停止後、メニュー表示
        e.preventDefault();
        if (this.fileContextMenu !== undefined) {
          this.fileSelectIndex = i;
          if (!this.kymw00Model.kymw1001Model.topFuncReadOnlyMode) {
            this.fileContextMenu.itemsSource[0].enabled = true;
          } else {
            this.fileContextMenu.itemsSource[0].enabled = false;
          }
          // メニュー表示
          this.fileContextMenu.show(e);
        }
      });
    }
  }

  public eventFileDelete_CLICKHandler(): void {
    const referenceImage = this.kymw0C00Model.referenceImageList[this.fileSelectIndex]
    if (referenceImage.registeredImageFileFlg) {
      const referenceImageDelete = new ReferenceImageDeleteList;
      referenceImageDelete.ImageID = this.kymw0C00Model.imageId;
      referenceImageDelete.ReferenceImageFileName = referenceImage.fileName;
      this.kymw0C00Model.workReferenceImageDeleteList.push(referenceImageDelete);
    }
    this.kymw0C00Model.referenceImageList.splice(this.fileSelectIndex, 1);
    this.eventDetail_CHANGEHandler();
  }

  /**
   * 右クリックメニューが表示されたときに呼び出されるメソッド
   *
   * @private
   * @param {Menu} contextMenu コンテキストメニュー
   * @param {*} selectedRow 現在選択されている行
   * @memberof KYMW0C00Component
   */
  private setDataGridContextMenuEnabled(contextMenu: Menu, selectedRow: any): void {

    if (!this.kymw00Model.kymw1001Model.topFuncReadOnlyMode) {
      // コンテキスト表示設定
      // && selectedRow.dataItem.editStatus === '削除') {
      if (!PlessViewUtilsSub.isEmpty(selectedRow.dataItem.imageID)
        && selectedRow.dataItem.editStatus === '削除') {
        contextMenu.itemsSource[0].enabled = false;
        contextMenu.itemsSource[1].enabled = true;
      } else {
        contextMenu.itemsSource[0].enabled = true;
        contextMenu.itemsSource[1].enabled = false;
      }
    } else {
      contextMenu.itemsSource[0].enabled = false;
      contextMenu.itemsSource[1].enabled = false;
    }
  }

  /** 画像作成指示 初期処理を行う */
  public eventSendGetImageGroupInfoEvent(imageID: string): void {
    this.getImageGroupInfoService.execute(this.kymw0C00Model, imageID, (serverData: any) => {
      this.kymw0C00Model.setImageGroupInfo(serverData);
    });
  }

  /**
   * 「(サンプル発注先取引先)検索」ボタン押下イベント処理
   *
   * @event イベント
   */
  public eventSampleOrderingSeach_ClickHandler(): void {
    const vo: KYMW0400InputModel = new KYMW0400InputModel();
    vo.supplierFlg = '0'; // 取引先
    this.openKymw0400(vo, (outputVO: KYMW0400OutputModel) => {
      this.kymw0C00Model.sampleOrderingCode = outputVO.supplierCode;
      this.kymw0C00Model.sampleSupplierNameKanji = outputVO.supplierNameKanji;
      // 画面全項目変更イベント処理の呼び出し
      this.eventHead_CHANGEHandler();
    });
  }

  /**
   * 「(請求先取引先)検索」ボタン押下イベント処理
   *
   * @event イベント
   */
  public eventBillingSeach_ClickHandler(): void {
    const vo: KYMW0400InputModel = new KYMW0400InputModel();
    vo.supplierFlg = '1'; // 請求先
    this.openKymw0400(vo, (outputVO: KYMW0400OutputModel) => {
      this.kymw0C00Model.billingCode = outputVO.supplierCode;
      this.kymw0C00Model.billingSupplierNameKanji = outputVO.supplierNameKanji;
      // 画面全項目変更イベント処理の呼び出し
      this.eventHead_CHANGEHandler();
    });
  }

  /**
   * KYMW0400「取引先一覧画面」を表示
   */
  private openKymw0400(vo: KYMW0400InputModel, returnFunction: Function) {
    const componentRef = this.dialogService.openModal(KYMW0400Component);
    const instance = componentRef.componentInstance as KYMW0400Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0400Parameter = (outputVO: KYMW0400OutputModel) => {
      returnFunction(outputVO);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * Pコード情報取得
   */
  public eventSendGetPCodeInfoEvent(pcode: string): void {
    // 「商品案内用商品名」及び「商品案内用規格名」のクリア処理を行う。
    // 「サンプル発注先コード」及び「サンプル発注先名称」のクリア処理を行う。
    // 「請求先コード」及び「請求先名称」のクリア処理を行う。
    // 「Pコード」の設定処理を行う。
    this.kymw0C00Model.guideGoodsName = '';
    this.kymw0C00Model.guideStandardName = '';
    this.kymw0C00Model.sampleOrderingCode = '';
    this.kymw0C00Model.sampleSupplierNameKanji = '';
    this.kymw0C00Model.billingCode = '';
    this.kymw0C00Model.billingSupplierNameKanji = '';
    this.kymw0C00Model.pCodeEnabled = false;
    this.kymw0C00Model.pCode = this.inputParam.pcode;

    this.getPCodeDataService.execute(this.kymw0C00Model, this.kymw0C00Model.pCode, (serverData: any) => {
      this.kymw0C00Model.setPCode(serverData);
    });
  }

  /**
   * @copy jp.co.toppan.pless.common.view.PlessViewHelper#eventListenerSetting()
   */
  protected eventListenerSetting(): void {
    // 全体変更イベントを登録する
    const changeObj: Array<string> = [
      'txti_StartOrderCode', 'txti_EndOrderCode', 'chk_EndOrderNothing', 'chk_eFriends',
      'chk_EndOrderEqual', 'cmb_ImageBelongID', 'txti_PCode', 'txti_SampleOrderingCode',
      'txti_BillingCode', 'cmb_PhotoStudioID', 'dtf_PhotoSchedule', 'chk_BillingTargetDiv',
      'txti_Memo', 'cmb_ImageKind',
    ];
    changeObj.forEach((objName: string) => {
      document.getElementById(objName).addEventListener('change', () => this.eventHead_CHANGEHandler());
    });

    // 詳細変更イベントを登録する
    const changeDetails: Array<string> = [
      'cmb_ImageType', 'cmb_ProcessInstruct', 'txta_Remarks', 'chk_CookingExPublish',
      'txti_KeyWord', 'cmb_CookingDiv', 'txti_CookingName', 'txti_MaterialName',
      'cmb_EventID', 'cmb_PhotoContentsDiv',
      'txti_Caption', 'cmb_ColorChange', 'txti_SampleNum',
      'txti_MultipleCode', 'chk_PromotionFlg', 'rbtn_Shooting1', 'rbtn_Shooting2',
      'rbtn_Shooting3', 'rbtn_Shooting4', 'rbtn_Shooting5', 'txti_ShootingPackageText',
      'rbtn_ShootingAngle1', 'rbtn_ShootingAngle2', 'rbtn_ShootingAngle3', 'rbtn_Alignment1',
      'txti_AlignmentHorizontal', 'txti_AlignmentVertical', 'rbtn_Alignment2', 'rbtn_Alignment3',
      'rbtn_Alignment4', 'rbtn_Alignment5', 'rbtn_Alignment6', 'txta_PhotoInstructContents1',
      'rbtn_VesselPlating1', 'rbtn_VesselPlating2', 'rbtn_VesselPlating3', 'rbtn_VesselPlating4', 
      'rbtn_VesselPlating5', 'rbtn_VesselPlating6', 'rbtn_Plating1', 'rbtn_Plating2', 
      'rbtn_Plating3', 'rbtn_Accompaniments1', 'rbtn_Accompaniments2', 'rbtn_Accompaniments3', 
      'rbtn_Accompaniments4', 'rbtn_Accompaniments5', 'rbtn_Accompaniments6', 'rbtn_QtyCookNecessary1', 
      'rbtn_QtyCookNecessary2', 'rbtn_QtyCookNecessary3', 'txti_QtyCookNecessaryNum', 'rbtn_QtyCookNecessary4', 
      'rbtn_QtyCookNecessary5', 'rbtn_QtyCookNecessary6', 'rbtn_QtyCookNecessary7', 'rbtn_QtyCookNecessary8', 
      'txti_QtyCookNecessaryVesselNum', 'rbtn_VesselShapeCookNecessary1', 'rbtn_VesselShapeCookNecessary2',
      'rbtn_VesselShapeCookNecessary3', 'rbtn_VesselShapeCookNecessary4', 'rbtn_VesselCookNecessary1',
      'rbtn_VesselCookNecessary2', 'rbtn_VesselCookNecessary3', 'rbtn_VesselCookNecessary4', 'rbtn_VesselCookNecessary5', 
      'rbtn_VesselCookNecessary6', 'rbtn_VesselCookNecessary7', 'rbtn_VesselCookNecessary8', 'rbtn_VesselCookNecessary9', 
      'rbtn_VesselCookNecessary10', 'rbtn_VesselCookNecessary11', 'rbtn_PhotoImageCookNecessary1', 'rbtn_PhotoImageCookNecessary2', 
      'rbtn_PhotoImageCookNecessary3', 'rbtn_PhotoImageCookNecessary4', 'rbtn_PhotoImageCookNecessary5',
      'rbtn_PhotoImageCookNecessary6', 'rbtn_PhotoImageCookNecessary7', 'rbtn_PhotoImageCookNecessary8',
      'rbtn_PhotoImageCookNecessary9', 'rbtn_PhotoImageCookNecessary10', 'chk_CrossSection1', 'rbtn_PhotoRenditionCookNecessary1', 
      'rbtn_PhotoRenditionCookNecessary2', 'rbtn_PhotoRenditionCookNecessary3', 'rbtn_PhotoRenditionCookNecessary4',
      'rbtn_QtyCookUnnecessary1', 'rbtn_QtyCookUnnecessary2', 'rbtn_QtyCookUnnecessary3', 'txti_QtyCookUnnecessaryNum', 
      'rbtn_QtyCookUnnecessary4', 'rbtn_QtyCookUnnecessary5', 'rbtn_QtyCookUnnecessary6', 'rbtn_QtyCookUnnecessary7', 
      'txti_QtyCookUnnecessaryVesselNum', 'rbtn_VesselShapeCookUnnecessary1', 'rbtn_VesselShapeCookUnnecessary2',
      'rbtn_VesselCookUnnecessary1', 'rbtn_VesselCookUnnecessary2', 'rbtn_VesselCookUnnecessary3', 'rbtn_VesselCookUnnecessary4', 
      'rbtn_VesselCookUnnecessary5', 'rbtn_VesselCookUnnecessary6', 'rbtn_VesselCookUnnecessary7', 'rbtn_VesselCookUnnecessary8', 
      'rbtn_VesselCookUnnecessary9', 'rbtn_VesselCookUnnecessary10', 'rbtn_PhotoImageCookUnnecessary1', 'rbtn_PhotoImageCookUnnecessary2', 
      'rbtn_PhotoImageCookUnnecessary3', 'rbtn_PhotoImageCookUnnecessary4', 'rbtn_PhotoImageCookUnnecessary5', 
      'chk_PhotoRenditionCookUnnecessary', 'rbtn_CropExistenceTypeD1', 'rbtn_CropExistenceTypeD2',
      'txta_PhotoInstructContents2', 'txta_PhotoInstructContents3', 'txta_PhotoInstructContents4',
      'txta_PhotoInstructContents5', 'txta_PhotoInstructContents6', 'txta_PhotoInstructContents7','chk_CrossSection2',
      'rbtn_CropExistenceTypeE1', 'rbtn_CropExistenceTypeE2'
    ];
    changeDetails.forEach((objName: string) => {
      document.getElementById(objName).addEventListener('change', () => this.eventDetail_CHANGEHandler());
    });

  }

  /*--------------------------------------------------------------------------------------------
  /* event area
  /*--------------------------------------------------------------------------------------------*/

  /**
   * 編集カウントをカウントする。
   */
  public eventEditHandler(): void {
    this.editFlag = true;
  }

  /**
   * 編集カウントをクリアする。
   */
  public clearEditCount(): void {
    this.editFlag = false;
  }

  /**
   * 画像種類変更イベント
   */
  public eventImageKind_CHANGEHandler(): void {
    this.kymw0C00Model.billingTargetDiv = (this.kymw0C00Model.imageKind === '1') ? true : false;
    this.kymw0C00Model.cropExistenceTypeEnabled = (this.kymw0C00Model.imageKind === '1') ? true : false;
    this.kymw0C00Model.cropExistenceType = '';
  }

  /**
   * 画面全項目変更イベントリスナ
   */
  public eventHead_CHANGEHandler(): void {
    this.kymw0C00Model.changeAllFlg = true;

    // 参照権限以外の場合
    if (!this.kymw0C00Model.funcPermissionViewer) {
      this.kymw0C00Model.btnOutputEnabled = false;
    }
  }

  /**
   * 画面詳細項目変更イベントリスナ
   */
  public eventDetail_CHANGEHandler(): void {
    this.kymw0C00Model.changeDetailFlg = true;
    // 詳細項目を変更した際は全項目イベントリスナも呼び出す
    this.eventHead_CHANGEHandler();
  }

  /**
   * 使用開始受注コード値変更時のイベントリスナ
   */
  public eventStartOrderCode_ChangedHandler(): void {

    // 使用開始配達企画回(翌週)に自動セットされた値を格納

    // 今回のみにチェックがある場合
    if (this.kymw0C00Model.endOrderEqual) {
      // 使用終了受注コードに使用開始受注コードを設定
      // 使用終了配達企画回(翌週)に使用開始配達企画回(翌週)を設定
      this.setEndOrderCode(this.kymw0C00Model.startOrderCode);
    }
  }

  /**
   * 使用終了受注コード値変更時のイベントリスナ
   */
  public eventEndOrderCode_ChangeHandler(): void {

    this.setEndOrderCode(this.kymw0C00Model.endOrderCode);

    // フル桁入力されているか確認
    if (this.kymw0C00Model.endOrderCode.length === 7) {
      // ・「使用開始受注コード」と「使用終了受注コード」の両方が入力され、受注コードの
      // 大小相関（From ≦ To）が異なる場合、下記のメッセージを表示し処理を終了する。
      // 		ID = E0123						%1 = '受注コード'
      if (!PlessViewUtilsSub.isEmpty(this.kymw0C00Model.endOrderCode)
        && Number(this.kymw0C00Model.startOrderCode) > Number(this.kymw0C00Model.endOrderCode)) {
        this.dialogService.openAlertGetMessage('E0123', ['受注コード']);
        return;
      }
    }
  }

  /**
   * サンプル発注先コード入力変更イベントリスナ
   */
  public eventSampleOrderingCode_ChangedHandler(): void {
    this.kymw0C00Model.sampleSupplierNameKanji = '';
    this.getSupplierName(this.kymw0C00Model.sampleOrderingCode, (serverData: any) => {
      this.kymw0C00Model.setSampleOrderingSupplierName(serverData);
    });
  }

  /**
   * 請求先コード入力変更イベントリスナ
   */
  public eventBillingCode_ChangedHandler(): void {
    this.kymw0C00Model.billingSupplierNameKanji = '';
    this.getSupplierName(this.kymw0C00Model.billingCode, (serverData: any) => {
      this.kymw0C00Model.setBillingCodeSupplierName(serverData);
    });
  }

  /** 発注先、請求先を取得する */
  private getSupplierName(supplierCode: string, settingFunction: Function) {
    if (supplierCode.length === 6) {
      this.getSupplierNameService.execute(this.kymw0C00Model, supplierCode, (serverData) => {
        settingFunction(serverData);
      });
    }
  }

  /**
   * Pコード変更リスナー
   */
  public eventPCode_ChangedHandler(): void {
    // 「商品案内用商品名」及び「商品案内用規格名」のクリア処理を行う。
    // 「サンプル発注先コード」及び「サンプル発注先名称」のクリア処理を行う。
    // 「請求先コード」及び「請求先名称」のクリア処理を行う。
    this.kymw0C00Model.guideGoodsName = '';
    this.kymw0C00Model.guideStandardName = '';
    this.kymw0C00Model.sampleOrderingCode = '';
    this.kymw0C00Model.sampleSupplierNameKanji = '';
    this.kymw0C00Model.billingCode = '';
    this.kymw0C00Model.billingSupplierNameKanji = '';

    // 8桁すべて入力された場合サーバ通信を行う
    if (this.kymw0C00Model.pCode.length === 8) {
      this.getPCodeDataService.execute(this.kymw0C00Model, this.kymw0C00Model.pCode, (serverData: any) => {
        this.kymw0C00Model.setPCode(serverData);
      });
    }
  }

  /**
   * 「無期限」チェック時のイベントリスナ
   */
  public eventEndOrderNothing_CheckHandler(): void {
    // チェックにより表示を変更する。
    if (this.kymw0C00Model.endOrderNothing) {
      // 「無期限」がチェックされた場合
      this.kymw0C00Model.endOrderCodeEnabled = false;     // 使用終了受注コードを非活性
      // 使用終了受注コード、 使用終了配達企画回(翌週)をクリア
      this.setEndOrderCode('');
      this.kymw0C00Model.endOrderEqual = false;    // 「今回のみ」のチェックを解除
    } else {
      // 「無期限」がチェック解除された場合
      this.kymw0C00Model.endOrderCodeEnabled = true; // 使用終了受注コードを活性
    }
  }

  /**
   * 「今回のみ」チェック時のイベントリスナ
   */
  public eventEndOrderEqual_CheckHandler(): void {
    // チェックにより表示を変更する。
    if (this.kymw0C00Model.endOrderEqual) {
      // 「今回のみ」がチェックされた場合
      // 使用終了受注コードを非活性
      this.kymw0C00Model.endOrderCodeEnabled = false;
      // 使用終了受注コードに使用開始受注コードを設定
      // 使用終了配達企画回(翌週)に使用開始配達企画回(翌週)を設定
      this.setEndOrderCode(this.kymw0C00Model.startOrderCode);
      // 「無期限」のチェックを解除
      this.kymw0C00Model.endOrderNothing = false;
    } else {
      // 「今回のみ」がチェック解除された場合
      this.kymw0C00Model.endOrderCodeEnabled = true; // 使用終了受注コードを活性
      // 使用終了受注コード、 使用終了配達企画回(翌週)をクリア
      this.setEndOrderCode('');
    }
  }

  /**
   * 画像種別変更時のイベントリスナ
   */
  public eventImageType_CHANGEDHandler(): void {
    if (this.cmb_ImageType.selectedCodeValue === 'C') {
      this.kymw0C00Model.clearPhotoCaution();
      this.cmb_ProcessInstruct.setCodeValue('1');         // 「調理指示」を「1：調理要」に設定
      this.kymw0C00Model.processInstruct = '1';  	        // 「調理指示」を「1：調理要」に設定
      this.kymw0C00Model.processInstructEnabled = true;		// 「調理指示」を活性化
      this.kymw0C00Model.cookingExPublish = true;    			// 「調理例掲載区分」をチェック
      this.kymw0C00Model.imageTypeStatusVisible = 'C1';   // 「調理イメージ(調理要)」の撮影注意事項を表示
    } else {
      this.kymw0C00Model.clearPhotoCaution();
      this.cmb_ProcessInstruct.setCodeValue('');          // 「調理指示」を「未選択」に設定
      this.kymw0C00Model.processInstruct = '';  	        // 「調理指示」を「未選択」に設定
      this.kymw0C00Model.processInstructEnabled = false;  // 「調理指示」を非活性化
      this.kymw0C00Model.cookingExPublish = false;				// 「調理例掲載区分」のチェックを解除
      if (this.cmb_ImageType.selectedCodeValue === 'A') {
        this.kymw0C00Model.clearPhotoCaution();
        this.kymw0C00Model.imageTypeStatusVisible = 'A';         // 「包材」の撮影注意事項を表示
      } else if (this.cmb_ImageType.selectedCodeValue === 'B') { 
        this.kymw0C00Model.clearPhotoCaution();
        this.kymw0C00Model.imageTypeStatusVisible = 'B';         // 「皿盛・ザル盛」の撮影注意事項を表示
      } else if (this.cmb_ImageType.selectedCodeValue === 'D') { 
        this.kymw0C00Model.clearPhotoCaution();
        this.kymw0C00Model.imageTypeStatusVisible = 'D';         // 「説明・素材」の撮影注意事項を表示
      } else if (this.cmb_ImageType.selectedCodeValue === 'E') { 
        this.kymw0C00Model.clearPhotoCaution();
        this.kymw0C00Model.imageTypeStatusVisible = 'E';         // 「その他」の撮影注意事項を表示
      } else if (this.cmb_ImageType.selectedCodeValue === 'F') { 
        this.kymw0C00Model.clearPhotoCaution();
        this.kymw0C00Model.imageTypeStatusVisible = 'F';         // 「裏面」の撮影注意事項を表示
      } else {
        this.kymw0C00Model.clearPhotoCaution();
        this.kymw0C00Model.imageTypeStatusVisible = '';         // 選択されなかった場合は空白を入れる
      }
    }
  }

  /**
   * 調理指示変更時のイベントリスナ
   */
  public eventProcessInstruct_CHANGEDHandler(): void {
    if (this.cmb_ImageType.selectedCodeValue === 'C' &&       // 「画像種別」が「調理イメージ」かつ
      this.kymw0C00Model.processInstruct === '1') {           // 「調理指示」が「1：調理要」の時
        this.kymw0C00Model.clearPhotoCaution();
        this.kymw0C00Model.imageTypeStatusVisible = 'C1';       // 「調理イメージ(調理要)」の撮影注意事項を表示
    }
    else if (this.cmb_ImageType.selectedCodeValue === 'C' &&  // 「画像種別」が「調理イメージ」かつ
      this.kymw0C00Model.processInstruct === '2') {           // 「調理指示」が「2：調理不要」の時
        this.kymw0C00Model.clearPhotoCaution();
        this.kymw0C00Model.imageTypeStatusVisible = 'C2';     // 「調理イメージ(調理不要)」の撮影注意事項を表示
    } else {
      this.kymw0C00Model.clearPhotoCaution();
      this.kymw0C00Model.imageTypeStatusVisible = '';
    }
  }
  /**
   * 「外包材と個包装」選択時のイベントリスナ
   */
  public eventShooting_CHANGEHandler(): void {
    if (this.kymw0C00Model.funcPermissionViewer) {
      this.kymw0C00Model.shootingPackageTextEnabled = false;          // 外包材と個包装テキストを非活性
      this.render.removeClass(this.txti_ShootingPackageText.input.nativeElement, 'text-label-required');
    } else {
      if (this.kymw0C00Model.shooting === '05') {               // ラジオボタンが「外包材と個包装」の場合
        this.kymw0C00Model.shootingPackageTextEnabled = true;   // 外包材と個包装テキストを活性
        this.render.addClass(this.txti_ShootingPackageText.input.nativeElement, 'text-label-required');
      } else {                                                  // 「ラジオボタンが「外包材と個包装」以外の場合
        this.kymw0C00Model.shootingPackageText = '';
        this.kymw0C00Model.shootingPackageTextEnabled = false;          // 外包材と個包装テキストを非活性
        this.render.removeClass(this.txti_ShootingPackageText.input.nativeElement, 'text-label-required');
      }
    }
  }

  /**
   * 「左手前に重ねる」選択時のイベントリスナ
   */
  public eventAlignment_CHANGEHandler(): void {
    if (this.kymw0C00Model.funcPermissionViewer) {
      this.kymw0C00Model.alignmentHorizontalEnabled = false;          // 横並テキストを非活性
      this.kymw0C00Model.alignmentVerticalEnabled = false;             // 縦並テキストを非活性
      this.render.removeClass(this.txti_AlignmentHorizontal.input.nativeElement, 'text-label-required');
      this.render.removeClass(this.txti_AlignmentVertical.input.nativeElement, 'text-label-required');
    } else {
      if (this.kymw0C00Model.alignment === '01') {               // ラジオボタンが「左手前に重ねる」」の場合
        this.kymw0C00Model.alignmentHorizontalEnabled = true;   // 横並テキストを活性
        this.kymw0C00Model.alignmentVerticalEnabled = true;   // 縦並テキストを活性
        this.render.addClass(this.txti_AlignmentHorizontal.input.nativeElement, 'text-label-required');
        this.render.addClass(this.txti_AlignmentVertical.input.nativeElement, 'text-label-required');
      } else {                                                  // 「ラジオボタンが「左手前に重ねる」以外の場合
        this.kymw0C00Model.alignmentHorizontal = '';
        this.kymw0C00Model.alignmentVertical = '';
        this.kymw0C00Model.alignmentHorizontalEnabled = false;          // 横並テキストを非活性
        this.kymw0C00Model.alignmentVerticalEnabled = false;             // 縦並テキストを非活性
        this.render.removeClass(this.txti_AlignmentHorizontal.input.nativeElement, 'text-label-required');
        this.render.removeClass(this.txti_AlignmentVertical.input.nativeElement, 'text-label-required');
      }
    }
  }

  /**
   * 「調理要_数量/個数 or 調理要_数量/器数」選択時のイベントリスナ
   */
  public eventQtyCookNecessary_CHANGEHandler(): void {
    if (this.kymw0C00Model.funcPermissionViewer) {
      this.kymw0C00Model.qtyCookNecessaryNumEnabled = false;           // 調理要_数量/個数テキストを非活性
      this.kymw0C00Model.qtyCookNecessaryVesselNumEnabled = false;     // 調理要_数量/器数テキストを非活性
      this.render.removeClass(this.txti_QtyCookNecessaryNum.input.nativeElement, 'text-label-required');
      this.render.removeClass(this.txti_QtyCookNecessaryVesselNum.input.nativeElement, 'text-label-required');
    } else {
      if (this.kymw0C00Model.qtyCookNecessary === '03') {               // ラジオボタンが「個」の場合
        this.kymw0C00Model.qtyCookNecessaryNumEnabled = true;           // 調理要_数量/個数テキストを活性
        this.kymw0C00Model.qtyCookNecessaryVesselNum = '';
        this.kymw0C00Model.qtyCookNecessaryVesselNumEnabled = false;     // 調理要_数量/器数テキストを非活性
        this.render.addClass(this.txti_QtyCookNecessaryNum.input.nativeElement, 'text-label-required');
        this.render.removeClass(this.txti_QtyCookNecessaryVesselNum.input.nativeElement, 'text-label-required');
      } else if (this.kymw0C00Model.qtyCookNecessary === '08') {         // ラジオボタンが「器数」の場合
        this.kymw0C00Model.qtyCookNecessaryVesselNumEnabled = true;     // 調理要_数量/器数テキストを活性
        this.kymw0C00Model.qtyCookNecessaryNum = '';
        this.kymw0C00Model.qtyCookNecessaryNumEnabled = false;           // 調理要_数量/個数テキストを非活性
        this.render.removeClass(this.txti_QtyCookNecessaryNum.input.nativeElement, 'text-label-required');
        this.render.addClass(this.txti_QtyCookNecessaryVesselNum.input.nativeElement, 'text-label-required');
      } else  {                                                          // 「ラジオボタンが「個」「器数」以外の場合
        this.kymw0C00Model.qtyCookNecessaryNum = '';
        this.kymw0C00Model.qtyCookNecessaryVesselNum = '';
        this.kymw0C00Model.qtyCookNecessaryNumEnabled = false;           // 調理要_数量/個数テキストを非活性
        this.kymw0C00Model.qtyCookNecessaryVesselNumEnabled = false;     // 調理要_数量/器数テキストを非活性
        this.render.removeClass(this.txti_QtyCookNecessaryNum.input.nativeElement, 'text-label-required');
        this.render.removeClass(this.txti_QtyCookNecessaryVesselNum.input.nativeElement, 'text-label-required');
      }
    }
  }

  /**
   * 「調理不要_数量/個数 or 調理不要_数量/器数」選択時のイベントリスナ
   */
  public eventQtyCookUnnecessary_CHANGEHandler(): void {
    if (this.kymw0C00Model.funcPermissionViewer) {
      this.kymw0C00Model.qtyCookUnnecessaryNumEnabled = false;           // 調理要_数量/個数テキストを非活性
      this.kymw0C00Model.qtyCookUnnecessaryVesselNumEnabled = false;     // 調理要_数量/器数テキストを非活性
      this.render.removeClass(this.txti_QtyCookUnnecessaryNum.input.nativeElement, 'text-label-required');
      this.render.removeClass(this.txti_QtyCookUnnecessaryVesselNum.input.nativeElement, 'text-label-required');
    } else {
      if (this.kymw0C00Model.qtyCookUnnecessary === '3') {               // ラジオボタンが「個」の場合
        this.kymw0C00Model.qtyCookUnnecessaryNumEnabled = true;           // 調理不要_数量/個数テキストを活性
        this.kymw0C00Model.qtyCookUnnecessaryVesselNum = '';
        this.kymw0C00Model.qtyCookUnnecessaryVesselNumEnabled = false;     // 調理不要_数量/器数テキストを非活性
        this.render.addClass(this.txti_QtyCookUnnecessaryNum.input.nativeElement, 'text-label-required');
        this.render.removeClass(this.txti_QtyCookUnnecessaryVesselNum.input.nativeElement, 'text-label-required');
      } else if (this.kymw0C00Model.qtyCookUnnecessary === '7') {         // ラジオボタンが「器数」の場合
        this.kymw0C00Model.qtyCookUnnecessaryVesselNumEnabled = true;     // 調理不要_数量/器数テキストを活性
        this.kymw0C00Model.qtyCookUnnecessaryNum = '';
        this.kymw0C00Model.qtyCookUnnecessaryNumEnabled = false;           // 調理不要_数量/個数テキストを非活性
        this.render.removeClass(this.txti_QtyCookUnnecessaryNum.input.nativeElement, 'text-label-required');
        this.render.addClass(this.txti_QtyCookUnnecessaryVesselNum.input.nativeElement, 'text-label-required');
      } else {                                                              // ラジオボタンが「個」「器数」以外の場合
        this.kymw0C00Model.qtyCookUnnecessaryNum = '';
        this.kymw0C00Model.qtyCookUnnecessaryVesselNum = '';
        this.kymw0C00Model.qtyCookUnnecessaryNumEnabled = false;           // 調理要_数量/個数テキストを非活性
        this.kymw0C00Model.qtyCookUnnecessaryVesselNumEnabled = false;     // 調理要_数量/器数テキストを非活性
        this.render.removeClass(this.txti_QtyCookUnnecessaryNum.input.nativeElement, 'text-label-required');
        this.render.removeClass(this.txti_QtyCookUnnecessaryVesselNum.input.nativeElement, 'text-label-required');
      }
    }
  }

  /**
   * 参考資料アップロードボタンのイベントリスナ
   * @param e イベント
   */
  // 選択ファイル
  private extension: string;
  public eventReferenceImage_CLICKHandler(): void {
    // ファイル選択ダイアログを開く
    this.fileUploadService.upload(async (selectedFiles: File[]) => {
      // ファイル件数が3件を超える場合
      if (this.kymw0C00Model.referenceImageList.length + selectedFiles.length > 3) {
        this.dialogService.openAlertGetMessage('E0544');
        return;
      }

      // 選択したファイルの拡張子チェック
      for (let i = Number(0); i < selectedFiles.length;) {
        this.extension = PlessViewUtilsSub.getExtension(selectedFiles[i].name);
        // 拡張子が異なる場合
        if (!this.extensions.includes(this.extension)) {
          this.dialogService.openAlertGetMessage('E0542');
          return;
        }
        // 17mb以上の場合
        if (selectedFiles[i].size > 17179869) {
          this.dialogService.openAlertGetMessage('E0543');
          return;
        }
        // 禁則文字チェック
        let fullFileName = selectedFiles[i].name;
        const fileExtension = PlessViewUtilsSub.getExtension(fullFileName);
        const fileName = fullFileName.replace(new RegExp(`(.*)\.${fileExtension}`), '$1');
        const found = fileName.match(this.forbiddenCharactersRegex);
        if (found) {
          this.dialogService.openAlertGetMessage('E0545', [found[0]]);
          return;
        }
        // 画像個別項目の画像ファイル名が設定されている場合、リネーム
        if (!PlessViewUtils.isEmpty(this.kymw0C00Model.imageFileName)) {
          fullFileName = this.kymw0C00Model.imageFileName + "_" + fullFileName;
        }
        // リネーム後の参考資料のファイル名が既にファイル名１～３に存在する場合エラーとする
        for(let j = Number(0); j < this.kymw0C00Model.referenceImageList.length; j++) {
          if (this.kymw0C00Model.referenceImageList[j].fileName == fullFileName) {
            this.dialogService.openAlertGetMessage('E0115', ['参考資料のファイル名']);
            return;
          }
        }
        // アップロードAPI実行用モデル
        let uploadFile = new ReferenceImageList();
        uploadFile.fileName = fullFileName;
        // リクエストのファイル名をリネーム後のファイル名にする
        uploadFile.file = new File([selectedFiles[i]], uploadFile.fileName, {
          type: selectedFiles[i].type,
          lastModified: selectedFiles[i].lastModified,
        })
        
        // アップロードAPI呼び出し 実行後trueが返却された場合にiをインクリメント
        const success = await this.eventFileRef_SELECTHandler(uploadFile);
        if (success) { i++ };
      }
      this.eventDetail_CHANGEHandler();
    }, [], true);
  }

  /**
   * 画像アップロード後イメージ選択ダイアログ選択イベント
   * 
   * @returns 完了時true
   */
  public async eventFileRef_SELECTHandler(uploadFile): Promise<any> {
    return new Promise(async (resolve) => {
      // fileRefのfileName変更
      const vo = this.kymw0C00Model.getReferenceImageFileUploadVO(uploadFile.file);
      // API実行
      this.referenceImageFileUploadService.execute(this.kymw0C00Model, vo, async () => {
        await this.eventFileRefUploadSUCCESS(uploadFile);
        resolve(true);
      });
    });
  }

  /**
   * アップロードしたファイルのurlを画面表示用にする
   * 
   * @param addItem
   */
  public async eventFileRefUploadSUCCESS(addItem): Promise<any> {
    // 画像ロード実行
    let src = await this.setUploadFile(addItem);

    // jpeg、pngの場合：画像イメージ表示
    // Excelの場合：Excelアイコン表示
    // PDFの場合：PDFアイコン表示
    if (this.excelExtensions.includes(this.extension)) {
      src = "./assets/icons/KYMW0C/ExcelLogo.png";
    } else if (this.extension == "pdf") {
      src = "./assets/icons/KYMW0C/pdfLogo.png";
    }
    addItem.src = src;
    addItem.registeredImageFileFlg = false;
    
    this.kymw0C00Model.referenceImageList.push(addItem);
  }

  /**
   * ロード実行
   * 
   * @param addItem 
   * @returns ロード完了後url
   */
  public async setUploadFile(addItem): Promise<any> {
    return new Promise((resolve) =>{
      const reader = new FileReader();
      reader.onload = (e) => {
        // ロード完了時urlを返却
        resolve(e.target?.result)
      }
      reader.readAsDataURL(addItem.file);
    })    
  }

  /**
   * 設定ボタンのイベントリスナ
   * @param e イベント
   */
  public eventSetting_CLICKHandler(): void {
    // 画面詳細変更フラグのチェック
    // 画面項目変更なしの場合は、更新処理は実行しない
    if (this.kymw0C00Model.changeDetailFlg === false) {
      this.dialogService.openAlertGetMessage('E0162');
      return;
    }

    // 「画像種別」コンボボックスが未指定の場合、メッセージを表示して処理を終了する。
    if (PlessViewUtilsSub.isEmpty(this.kymw0C00Model.imageType)) {
      this.dialogService.openAlertGetMessage('E0103', ['画像種別']);
      return;
    }

    // 「画像種別」コンボボックスで「調理イメージ」を選択し、
    // 「調理指示」コンボボックスが未指定の場合、メッセージを表示して処理を終了する。
    if (this.kymw0C00Model.imageType === 'C' && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.processInstruct)) {
      this.dialogService.openAlertGetMessage('E0107', ['画像種別で「C:調理イメージ」', '調理指示']);
      return;
    }

    if (this.kymw0C00Model.shooting === '05' && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.shootingPackageText)) {
      this.dialogService.openAlertGetMessage('W0001', ['撮影／外包材と個包装']);
      return;
    }

    if (this.kymw0C00Model.alignment === '01' && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.alignmentHorizontal)) {
      this.dialogService.openAlertGetMessage('W0001', ['並べ方／横']);
      return;
    }

    if (this.kymw0C00Model.alignment === '01' && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.alignmentVertical)) {
      this.dialogService.openAlertGetMessage('W0001', ['並べ方／縦']);
      return;
    }

    if (this.kymw0C00Model.qtyCookNecessary === '03' && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.qtyCookNecessaryNum)) {
      this.dialogService.openAlertGetMessage('W0001', ['数量／個数']);
      return;
    }

    if (this.kymw0C00Model.qtyCookNecessary === '08' && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.qtyCookNecessaryVesselNum)) {
      this.dialogService.openAlertGetMessage('W0001', ['数量／器数']);
      return;
    }

    if (this.kymw0C00Model.qtyCookUnnecessary === '3' && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.qtyCookUnnecessaryNum)) {
      this.dialogService.openAlertGetMessage('W0001', ['数量／個数']);
      return;
    }

    if (this.kymw0C00Model.qtyCookUnnecessary === '7' && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.qtyCookUnnecessaryVesselNum)) {
      this.dialogService.openAlertGetMessage('W0001', ['数量／器数']);
      return;
    }

    // ・指示リストに未登録のデータであれば、登録上限チェック処理を行う。
    // ・今回追加する画像種別ごとのデータ数が上限を超過していないかチェックする。
    // 　※上限件数はコードマスタPに設定し、画面．初期表示イベントで取得する
    // 　【今回追加により、超過する画像種別が1つでも存在する】
    // ・エラーメッセージを表示して処理を終了する。
    const selectedCount = this.dtg_ImageInstructList.selectedRows.length;
    if (selectedCount === 0) {
      // 選択された行がない場合は、新規と判断し、上限数チェック
      if (this.isOverImageType(this.kymw0C00Model.imageType)) {
        this.dialogService.openAlertGetMessage('E0178', ['選択された画像種別']);
        return;
      }
    }

    // 撮影注意事項の未入力チェック
    if (this.imageTypeStatusInputCheck()) {
      this.dialogService.openAlertGetMessage('Q0195', [], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          this.setImageInstructList(selectedCount);
        }
      });
    } else {
      this.setImageInstructList(selectedCount);
    }
  }

  /**
   * 撮影注意事項入力チェックメソッド
   */
  private imageTypeStatusInputCheck(): boolean {
    // 必須チェック
    if (this.kymw0C00Model.imageTypeStatusVisible === 'A'
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.shooting)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.shootingPackageText)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.shootingAngle)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.alignment)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.alignmentHorizontal)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.alignmentVertical)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.photoInstructContents)) {
        // 画像種別：包材、対象の項目が全て未入力の場合
        return true;
    } else if (this.kymw0C00Model.imageTypeStatusVisible === 'B'
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.vesselPlating)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.colorChange)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.plating)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.accompaniments)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.photoInstructContents)) {
        // 画像種別：皿盛・ザル盛、対象の項目が全て未入力の場合
        return true;
    } else if (this.kymw0C00Model.imageTypeStatusVisible === 'C1'
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.qtyCookNecessary)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.qtyCookNecessaryNum)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.qtyCookNecessaryVesselNum)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.vesselShapeCookNecessary)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.vesselCookNecessary)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.photoImageCookNecessary)
      && this.kymw0C00Model.crossSection == false
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.photoRenditionCookNecessary)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.photoInstructContents)) {
        // 画像種別：調理イメージ(調理要)、対象の項目が全て未入力の場合
        return true;
    } else if (this.kymw0C00Model.imageTypeStatusVisible === 'C2'
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.qtyCookUnnecessary)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.qtyCookUnnecessaryNum)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.qtyCookUnnecessaryVesselNum)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.vesselShapeCookUnnecessary)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.vesselCookUnnecessary)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.photoImageCookUnnecessary)
      && this.kymw0C00Model.crossSection == false
      && this.kymw0C00Model.photoRenditionCookUnnecessary == false
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.photoInstructContents)) {
        // 画像種別：調理イメージ(調理不要)、対象の項目が全て未入力の場合
        return true;
    } else if (this.kymw0C00Model.imageTypeStatusVisible === 'D'
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.cropExistenceType)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.photoInstructContents)) {
        // 画像種別：説明・素材、対象の項目が全て未入力の場合
        return true;
    } else if (this.kymw0C00Model.imageTypeStatusVisible === 'E'
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.cropExistenceType)
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.photoInstructContents)) {
        // 画像種別：その他、対象の項目が全て未入力の場合
        return true;
    } else if (this.kymw0C00Model.imageTypeStatusVisible === 'F'
      && PlessViewUtilsSub.isEmpty(this.kymw0C00Model.photoInstructContents)) {
        // 画像種別：裏面、対象の項目が全て未入力の場合
        return true;
    }
    return false;
  }

  /**
   * 画像作成指示リスト設定メソッド
   */
  private setImageInstructList(selectedCount: number): void {
    // リスト更新・追加情報を取得する
    if (selectedCount > 0) {
      const newList = Array<ImageInstructListRowModel>();
      const rowData = this.dtg_ImageInstructList.selectedRows[0].dataItem;
      const rowIndex = this.dtg_ImageInstructList.selectedRows[0].index;

      const cv: wjcCore.ICollectionView = this.dtg_ImageInstructList.collectionView;
      cv.items.forEach((data: ImageInstructListRowModel) => {
        if (rowData.imageID === data.imageID) {
          const updateData: any = this.getImageInfoObject();
          updateData.editStatus = (rowData.imageName === '*********') ? '新規' : '更新';
          newList.push(updateData);
        } else {
          const model: ImageInstructListRowModel = new ImageInstructListRowModel();
          model.imageID = data.imageID;
          model.imageBelongIDName = data.imageBelongIDName;
          model.imageName = data.imageName;
          model.imageFileName = data.imageFileName;
          model.status = data.status;
          model.statusName = data.statusName;
          model.imageType = data.imageType;
          model.imageTypeName = data.imageTypeName;
          model.processInstruct = data.processInstruct;
          model.processInstructName = data.processInstructName;
          model.cookingExPublish = data.cookingExPublish;
          model.cookingDiv = data.cookingDiv;
          model.cookingName = data.cookingName;
          model.materialName = data.materialName;
          model.eventID = data.eventID;
          model.photoContentsDiv = data.photoContentsDiv;
          model.remarks = data.remarks;
          model.keyWord = data.keyWord;
          model.textCaption = data.textCaption;
          model.photoInstructContents = data.photoInstructContents;
          model.editStatus = data.editStatus;
          model.colorChange = data.colorChange;
          model.multipleCode = data.multipleCode;
          model.sampleNum = data.sampleNum;
          model.promotionFlg = data.promotionFlg;
          model.shooting = data.shooting;
          model.shootingPackageText = data.shootingPackageText;
          model.shootingAngle = data.shootingAngle;
          model.alignment = data.alignment;
          model.alignmentHorizontal = data.alignmentHorizontal;
          model.alignmentVertical = data.alignmentVertical;
          model.vesselPlating = data.vesselPlating;
          model.plating = data.plating;
          model.accompaniments = data.accompaniments;
          model.qtyCookNecessary = data.qtyCookNecessary;
          model.qtyCookNecessaryNum = data.qtyCookNecessaryNum;
          model.qtyCookNecessaryVesselNum = data.qtyCookNecessaryVesselNum;
          model.vesselShapeCookNecessary = data.vesselShapeCookNecessary;
          model.vesselCookNecessary = data.vesselCookNecessary;
          model.photoImageCookNecessary = data.photoImageCookNecessary;
          model.crossSection = data.crossSection;
          model.photoRenditionCookNecessary = data.photoRenditionCookNecessary;
          model.qtyCookUnnecessary = data.qtyCookUnnecessary;
          model.qtyCookUnnecessaryNum = data.qtyCookUnnecessaryNum;
          model.qtyCookUnnecessaryVesselNum = data.qtyCookUnnecessaryVesselNum;
          model.vesselShapeCookUnnecessary = data.vesselShapeCookUnnecessary;
          model.vesselCookUnnecessary = data.vesselCookUnnecessary;
          model.photoImageCookUnnecessary = data.photoImageCookUnnecessary;
          model.photoRenditionCookUnnecessary = data.photoRenditionCookUnnecessary;
          model.cropExistenceType = data.cropExistenceType;
          model.referenceImageFileName1 = data.referenceImageFileName1;
          model.photoInstructContents1 = data.photoInstructContents1;
          model.imageSrc1 = data.imageSrc1;
          model.registeredImageFileFlg1 = data.registeredImageFileFlg1;
          model.referenceImageFileName2 = data.referenceImageFileName2;
          model.photoInstructContents2 = data.photoInstructContents2;
          model.imageSrc2 = data.imageSrc2;
          model.registeredImageFileFlg2 = data.registeredImageFileFlg2;
          model.referenceImageFileName3 = data.referenceImageFileName3;
          model.photoInstructContents3 = data.photoInstructContents3;
          model.imageSrc3 = data.imageSrc3;
          model.registeredImageFileFlg3 = data.registeredImageFileFlg3;
          newList.push(model);
        }
      });

      // バインド変数とリストを更新
      this.kymw0C00Model.imageInstructList = newList;
      this.dtg_ImageInstructList.itemsSource = newList;
      const grid = new CellRange(rowIndex, -1);
      this.dtg_ImageInstructList.select(grid, false);
    } else {
      const updateData: any = this.getImageInfoObject();
      // 選択された行がない場合は新規
      updateData.editStatus = '新規';
      const cv = this.dtg_ImageInstructList.collectionView;
      const sortDirection = this.dtg_ImageInstructList.collectionView.sortDescriptions.map(function (sortDesc) {
        return { property: sortDesc.property, ascending: sortDesc.ascending };
      });
      cv.sortDescriptions.clear();
      cv.items.push(updateData);
      for (let i = 0; i < sortDirection.length; i++) {
        const sortDesc = sortDirection[i];
        cv.sortDescriptions.push(
          new wjcCore.SortDescription(sortDesc.property, sortDesc.ascending)
        );
      }
      cv.refresh();
      this.kymw0C00Model.imageTypeEnabled = false;
      const grid = new CellRange(this.dtg_ImageInstructList.itemsSource.length - 1, -1);
      this.dtg_ImageInstructList.select(grid, false);
    }

    // 詳細変更フラグ初期化
    this.kymw0C00Model.changeDetailFlg = false;

    this.kymw0C00Model.workReferenceImageDeleteList.forEach(referenceImageDelete => this.kymw0C00Model.referenceImageDeleteList.push(referenceImageDelete));
    this.kymw0C00Model.workReferenceImageDeleteList = new Array<ReferenceImageDeleteList>();
  }

  /**
   * 新規ボタンのイベントリスナ
   * @param e イベント
   */
  public eventNewImage_CLICKkHandler(): void {
    // 変更フラグにて確認メッセージ表示
    if (this.kymw0C00Model.changeDetailFlg) {
      // 確認メッセージを表示
      this.dialogService.openAlertGetMessage('Q0107', ['画像個別項目'], (closeDetail: any) => {
        // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
        if (closeDetail === PlessAlert.Yes) {
          this.eventNewImage_CLICKConfirmHandler();
        } else {
          document.getElementById('cmb_ImageType').focus();
        }
      });
    } else {
      this.eventNewImage_CLICKConfirmHandler();
    }
  }

  /**
   * 新規ボタン確認
   *  @event イベント
   */
  public eventNewImage_CLICKConfirmHandler(): void {
    // 一覧選択をなくす
    this.dtg_ImageInstructList.select(-1, -1);
    this.kymw0C00Model.clearImageInfoDetail();
    this.kymw0C00Model.imageTypeEnabled = true;
    this.kymw0C00Model.btnSettingEnabled = true;
    this.kymw0C00Model.editMode = '1';
    this.kymw0C00Model.workReferenceImageDeleteList = new Array<ReferenceImageDeleteList>();
  }

  /**
   * コンテキスト「削除」選択イベント処理
   *  @event イベント
   */
  public eventDelete_CLICKHandler(): void {
    const row: any = this.dtg_ImageInstructList.selectedRows[0];

    if (row.dataItem.status === '2') {
      this.dialogService.openAlertGetMessage('E0164', ['画像登録済み', '削除']);
    } else {
      // 削除確認メッセージを表示
      this.dialogService.openAlertGetMessage('Q0106', ['選択している画像作成指示情報'], (closeDetail) => {
        // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
        if (closeDetail === PlessAlert.Yes) {
          this.eventDeleteImage_CLICKConfirmHandler();
        }
      });
    }
  }

  /**
   * コンテキスト「削除」確認
   *  @event イベント
   */
  public eventDeleteImage_CLICKConfirmHandler(): void {
    const row: any = this.dtg_ImageInstructList.selectedRows[0];

    // 全体編集カウントのアップ
    this.eventHead_CHANGEHandler();

    if (!PlessViewUtilsSub.isEmpty(row.dataItem.editStatus) && row.dataItem.editStatus === '新規') {
      // データグリッドから削除
      const ecv = this.dtg_ImageInstructList.editableCollectionView;
      ecv.remove(ecv.currentItem);

      // 個別項目.新規ボタン押下時のイベントを実行
      this.eventNewImage_CLICKConfirmHandler();
    } else {
      row.dataItem.editStatus = '削除';
      this.dtg_ImageInstructList.refresh();
      this.kymw0C00Model.btnSettingEnabled = false;
    }
  }

  /**
   * コンテキスト「削除取消」選択イベント処理
   */
  public eventUnDelete_CLICKHandler(): void {
    const row: any = this.dtg_ImageInstructList.selectedRows[0];

    if (row.dataItem.editStatus === '削除') {
      row.dataItem.editStatus = '更新';
      this.dtg_ImageInstructList.refresh();
      this.kymw0C00Model.btnSettingEnabled = true;
    }
  }

  /**
   * 商品一覧を選択した時に呼び出されるメソッド。
   * @param e マウスイベントの参照
   * @param grid 対象のFlexGrid
   * @event 商品一覧をクリック
   */
  public eventImageInstructList_CLICKHandler(e: MouseEvent, grid: FlexGrid): void {

    setTimeout(() => {
      if (PlessViewUtilsSub.isEmptyArray(this.dtg_ImageInstructList.selectedRows)) {
        return;
      }
      // 現在選択中の行が選択された場合は何もしない
      const rowData = this.dtg_ImageInstructList.selectedRows[0].dataItem;
      const cv: wjcCore.ICollectionView = this.dtg_ImageInstructList.collectionView;
      if (this.kymw0C00Model.imageId === rowData.imageID) {
        return;
      }

      // 変更フラグにて確認メッセージ表示
      if (this.kymw0C00Model.changeDetailFlg) {
        // 確認メッセージを表示
        this.dialogService.openAlertGetMessage('Q0107', ['画像個別項目'], (closeDetail: any) => {
          // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
          if (closeDetail === PlessAlert.Yes) {
            this.eventImageInstructList_CLICKConfirmHandler();
          } else {
            // 行選択を戻した場合にselectionChangedイベントを発生させないためにハンドラーを一時的に削除
            this.removeEventImageInstructListCLICKHandler();

            // 以前選択されている行にカーソルを移動する
            this.dtg_ImageInstructList.select(this.getSelectedImageIDIndex(), -1);
            this.cmb_ImageType.setFocus();

            // 上で削除したselectionChangedイベントを元に戻すため追加
            this.addEventImageInstructListCLICKHandler();
          }
        });
      } else {
        this.eventImageInstructList_CLICKConfirmHandler();
      }
    });
  }

  /**
   * 商品一覧をクリックした時に呼び出されるメソッド。
   */
  public eventImageInstructList_CLICKConfirmHandler(): void {

    if (PlessViewUtilsSub.isEmptyArray(this.dtg_ImageInstructList.selectedRows)) {
      return;
    }
    // 詳細クリア処理
    this.kymw0C00Model.clearImageInfoDetail();

    // 選択情報表示
    const selectedRow: any = this.dtg_ImageInstructList.selectedRows[0];

    this.kymw0C00Model.imageId = selectedRow.dataItem.imageID;
    this.kymw0C00Model.imageName = selectedRow.dataItem.imageName;
    this.kymw0C00Model.imageFileName = selectedRow.dataItem.imageFileName;
    this.kymw0C00Model.status = selectedRow.dataItem.status;
    this.kymw0C00Model.statusName = selectedRow.dataItem.statusName;
    this.kymw0C00Model.imageType = selectedRow.dataItem.imageType;
    this.kymw0C00Model.processInstruct = selectedRow.dataItem.processInstruct;
    this.kymw0C00Model.cookingExPublish = PlessViewUtilsSub.StringTOBoolean(selectedRow.dataItem.cookingExPublish);
    this.kymw0C00Model.cookingDiv = selectedRow.dataItem.cookingDiv;
    this.kymw0C00Model.cookingName = selectedRow.dataItem.cookingName;
    this.kymw0C00Model.materialName = selectedRow.dataItem.materialName;
    this.kymw0C00Model.keyWord = selectedRow.dataItem.keyWord;
    this.kymw0C00Model.textCaption = selectedRow.dataItem.textCaption;
    this.kymw0C00Model.photoInstructContents = PlessViewUtilsSub.nullToBlank(selectedRow.dataItem.photoInstructContents);
    this.kymw0C00Model.remarks = selectedRow.dataItem.remarks;
    this.kymw0C00Model.eventID = selectedRow.dataItem.eventID;
    this.kymw0C00Model.photoContentsDiv = selectedRow.dataItem.photoContentsDiv;
    this.kymw0C00Model.multipleCode = selectedRow.dataItem.multipleCode;
    this.kymw0C00Model.promotionFlg = selectedRow.dataItem.promotionFlg;
    this.kymw0C00Model.sampleNum = selectedRow.dataItem.sampleNum;
    this.kymw0C00Model.colorChange = selectedRow.dataItem.colorChange;
    this.kymw0C00Model.crossSection = selectedRow.dataItem.crossSection;
    this.kymw0C00Model.photoRenditionCookUnnecessary = selectedRow.dataItem.photoRenditionCookUnnecessary;
    this.kymw0C00Model.shooting = selectedRow.dataItem.shooting;
    this.kymw0C00Model.shootingPackageText = selectedRow.dataItem.shootingPackageText;
    this.kymw0C00Model.shootingAngle = selectedRow.dataItem.shootingAngle;
    this.kymw0C00Model.alignment = selectedRow.dataItem.alignment;
    this.kymw0C00Model.alignmentHorizontal = selectedRow.dataItem.alignmentHorizontal;
    this.kymw0C00Model.alignmentVertical = selectedRow.dataItem.alignmentVertical;
    this.kymw0C00Model.vesselPlating = selectedRow.dataItem.vesselPlating;
    this.kymw0C00Model.plating = selectedRow.dataItem.plating;
    this.kymw0C00Model.accompaniments = selectedRow.dataItem.accompaniments;
    this.kymw0C00Model.qtyCookNecessary = selectedRow.dataItem.qtyCookNecessary;
    this.kymw0C00Model.qtyCookNecessaryNum = selectedRow.dataItem.qtyCookNecessaryNum;
    this.kymw0C00Model.qtyCookNecessaryVesselNum = selectedRow.dataItem.qtyCookNecessaryVesselNum;
    this.kymw0C00Model.vesselShapeCookNecessary = selectedRow.dataItem.vesselShapeCookNecessary;
    this.kymw0C00Model.vesselCookNecessary = selectedRow.dataItem.vesselCookNecessary;
    this.kymw0C00Model.photoImageCookNecessary = selectedRow.dataItem.photoImageCookNecessary;
    this.kymw0C00Model.photoRenditionCookNecessary = selectedRow.dataItem.photoRenditionCookNecessary;
    this.kymw0C00Model.qtyCookUnnecessary = selectedRow.dataItem.qtyCookUnnecessary;
    this.kymw0C00Model.qtyCookUnnecessaryNum = selectedRow.dataItem.qtyCookUnnecessaryNum;
    this.kymw0C00Model.qtyCookUnnecessaryVesselNum = selectedRow.dataItem.qtyCookUnnecessaryVesselNum;
    this.kymw0C00Model.vesselShapeCookUnnecessary = selectedRow.dataItem.vesselShapeCookUnnecessary;
    this.kymw0C00Model.vesselCookUnnecessary = selectedRow.dataItem.vesselCookUnnecessary;
    this.kymw0C00Model.photoImageCookUnnecessary = selectedRow.dataItem.photoImageCookUnnecessary;
    this.kymw0C00Model.cropExistenceType = selectedRow.dataItem.cropExistenceType;

    // 参考資料画像リストの作成
    const referenceImageList = new Array<ReferenceImageList>();
    if (!PlessViewUtilsSub.isEmpty(selectedRow.dataItem.referenceImageFileName1)) {
      const addItem = new ReferenceImageList();
      addItem.src = this.getExtensionImage(selectedRow.dataItem.imageSrc1);
      addItem.fileName = selectedRow.dataItem.referenceImageFileName1;
      addItem.photoInstructContents = selectedRow.dataItem.photoInstructContents1;
      addItem.registeredImageFileFlg = selectedRow.dataItem.registeredImageFileFlg1;
      referenceImageList.push(addItem);
    }
    if (!PlessViewUtilsSub.isEmpty(selectedRow.dataItem.referenceImageFileName2)) {
      const addItem = new ReferenceImageList();
      addItem.src = this.getExtensionImage(selectedRow.dataItem.imageSrc2);
      addItem.fileName = selectedRow.dataItem.referenceImageFileName2;
      addItem.photoInstructContents = selectedRow.dataItem.photoInstructContents2;
      addItem.registeredImageFileFlg = selectedRow.dataItem.registeredImageFileFlg2;
      referenceImageList.push(addItem);
    }
    if (!PlessViewUtilsSub.isEmpty(selectedRow.dataItem.referenceImageFileName3)) {
      const addItem = new ReferenceImageList();
      addItem.src = this.getExtensionImage(selectedRow.dataItem.imageSrc3);
      addItem.fileName = selectedRow.dataItem.referenceImageFileName3;
      addItem.photoInstructContents = selectedRow.dataItem.photoInstructContents3;
      addItem.registeredImageFileFlg = selectedRow.dataItem.registeredImageFileFlg3;
      referenceImageList.push(addItem);
    }
    this.kymw0C00Model.referenceImageList = referenceImageList;
    this.kymw0C00Model.workReferenceImageDeleteList = new Array<ReferenceImageDeleteList>();

    // 選択後処理
    this.kymw0C00Model.imageTypeEnabled = false;

    // 画像種類が「調理イメージ」の場合、「調理指示」を活性
    if (this.kymw0C00Model.imageType === 'C') {
      this.kymw0C00Model.processInstructEnabled = true;		// 「調理指示」を活性化
    }

    // 編集状態にて設定ボタン非活性化
    if (!this.kymw0C00Model.funcPermissionViewer) {
      this.kymw0C00Model.btnSettingEnabled = (selectedRow.dataItem.editStatus === '削除') ? false : true;
    }

    // 詳細変更フラグ初期化
    this.kymw0C00Model.changeDetailFlg = false;

    // 撮影注意事項表示り替え処理
    if (this.kymw0C00Model.imageType === 'A') {
      // 「包材」の撮影注意事項を表示
      this.kymw0C00Model.imageTypeStatusVisible = 'A';
      this.eventShooting_CHANGEHandler();
      this.eventAlignment_CHANGEHandler();
    } else if (this.kymw0C00Model.imageType === 'B') {
      // 「皿盛・ザル盛」の撮影注意事項を表示 
      this.kymw0C00Model.imageTypeStatusVisible = 'B';
    } else if (this.kymw0C00Model.imageType === 'C') {
      if (this.kymw0C00Model.processInstruct === '1') {
        // 「調理イメージ(調理要)」の撮影注意事項を表示
        this.kymw0C00Model.imageTypeStatusVisible = 'C1';
        this.eventQtyCookNecessary_CHANGEHandler();
      } else if (this.kymw0C00Model.processInstruct === '2') {
        // 「調理イメージ(調理不要)」の撮影注意事項を表示
        this.kymw0C00Model.imageTypeStatusVisible = 'C2';
        this.eventQtyCookUnnecessary_CHANGEHandler();
      }
    } else if (this.kymw0C00Model.imageType === 'D') {
      // 「説明・素材」の撮影注意事項を表示
      this.kymw0C00Model.imageTypeStatusVisible = 'D';
      if (this.kymw0C00Model.imageKind === '1') {
        this.kymw0C00Model.cropExistenceTypeEnabled = true;
      } else {
        this.kymw0C00Model.cropExistenceTypeEnabled = false;
        this.kymw0C00Model.cropExistenceType = '';
      }
    } else if (this.kymw0C00Model.imageType === 'E') {
      // 「その他」の撮影注意事項を表示
      this.kymw0C00Model.imageTypeStatusVisible = 'E';
      if (this.kymw0C00Model.imageKind === '1') {
        this.kymw0C00Model.cropExistenceTypeEnabled = true;
      } else {
        this.kymw0C00Model.cropExistenceTypeEnabled = false;
        this.kymw0C00Model.cropExistenceType = '';
      }
    } else if (this.kymw0C00Model.imageType === 'F') {
      // 「裏面」の撮影注意事項を表示 
      this.kymw0C00Model.imageTypeStatusVisible = 'F';
    } else {
      // 選択されなかった場合は空白を入れる
      this.kymw0C00Model.imageTypeStatusVisible = '';
    }
  }

  /**
   * 更新ボタンイベントリスナー
   * @event
   */
  public eventUpdate_ClickHandler(): void {
    // 画面全体変更フラグ、画面詳細変更フラグのチェック
    // 画面項目変更なしの場合は、更新処理は実行しない
    if (this.kymw0C00Model.changeAllFlg === false && this.kymw0C00Model.changeDetailFlg === false) {
      this.dialogService.openAlertGetMessage('E0162');
      return;
    }

    if (!this.kymw0C00Model.changeDetailFlg) {
      this.eventUpdate_ClickConfirmHandler();
      return;
    }

    // 確認メッセージを表示
    this.dialogService.openAlertGetMessage('Q0107', ['画面個別項目'], (closeDetail) => {
      // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
      if (closeDetail === PlessAlert.Yes) {
        // 「OK」が選択された場合、画面詳細変更フラグをOFFにする(複数回の確認は行わない)
        this.kymw0C00Model.changeDetailFlg = false;
        this.eventUpdate_ClickConfirmHandler();
      } else {
        document.getElementById('cmb_ImageType').focus();
      }
    });
  }

  /**
   * 更新ボタンイベントリスナー確認
   * @event
   */
  public eventUpdate_ClickConfirmHandler(): void {

    // 登録処理を行う
    // 「使用開始受注コード」が未入力の場合、以下のメッセージを表示して処理を終了する。
    if (PlessViewUtilsSub.isEmpty(this.kymw0C00Model.startOrderCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['使用開始受注コード']);
      return;
    }
    // 使用開始受注コードが該当がないデータの場合
    if (PlessViewUtilsSub.isEmpty(this.txti_StartOrderCode.selectedCatalogID)) {
      this.dialogService.openAlertGetMessage('E0206', ['使用開始受注コード']);
      return;
    }

    // 「使用終了受注コード」と「無期限」チェックボックス「今回のみ」チェックボックスの関係が
    if ((PlessViewUtilsSub.isEmpty(this.kymw0C00Model.endOrderCode) &&
      !this.kymw0C00Model.endOrderNothing && this.kymw0C00Model.endOrderEqual) ||
      (PlessViewUtilsSub.isEmpty(this.kymw0C00Model.endOrderCode) &&
        !this.kymw0C00Model.endOrderNothing && !this.kymw0C00Model.endOrderEqual)) {
      this.dialogService.openAlertGetMessage('E0110', ['使用終了受注コード']);
      return;
    }

    // 使用終了受注コードが該当データが無い場合(編集モード対応)
    if (PlessViewUtilsSub.isEmpty(this.txti_EndOrderCode.selectedCatalogID) &&
      !(this.kymw0C00Model.endOrderNothing) &&
      !PlessViewUtilsSub.isEmpty(this.kymw0C00Model.endOrderCode)) {
      this.dialogService.openAlertGetMessage('E0206', ['使用終了受注コード']);
      return;
    }

    // 「使用開始受注コード」と「使用終了受注コード」の両方が入力され、受注コードの
    // 大小相関（From ≦ To）が異なる場合、下記のメッセージを表示し処理を終了する。
    if (!PlessViewUtilsSub.isEmpty(this.kymw0C00Model.endOrderCode) &&
      Number(this.kymw0C00Model.startOrderCode) > Number(this.kymw0C00Model.endOrderCode)) {
      this.dialogService.openAlertGetMessage('E0123', ['受注コード']);
      return;
    }

    // 「所属」が未選択の場合、以下のメッセージを表示して処理を終了する。
    if (PlessViewUtilsSub.isEmpty(this.kymw0C00Model.imageBelongID)) {
      this.dialogService.openAlertGetMessage('E0103', ['所属']);
      return;
    }

    // 「所属」を元に下記の条件で入力チェック処理を行う。
    const imageBelongID: string = this.kymw0C00Model.imageBelongID;
    // 1：食品、2：非食品の場合
    if (imageBelongID === '1' || imageBelongID === '2') {
      // 「サンプル発注先コード」が未入力の場合、以下のメッセージを表示して処理を終了する。
      if (PlessViewUtilsSub.isEmpty(this.kymw0C00Model.sampleOrderingCode)) {
        this.dialogService.openAlertGetMessage('E0106', ['「1:食品」「2:非食品」', 'サンプル発注先コード']);
        return;
      }
      // 「請求先コード」が未入力の場合、以下のメッセージを表示して処理を終了する。
      if (PlessViewUtilsSub.isEmpty(this.kymw0C00Model.billingCode)) {
        this.dialogService.openAlertGetMessage('E0106', ['「1:食品」「2:非食品」', '請求先コード']);
        return;
      }
      // 「Ｐコード」が未入力の場合、以下のメッセージを表示して処理を終了する。
      if (PlessViewUtilsSub.isEmpty(this.kymw0C00Model.pCode)) {
        this.dialogService.openAlertGetMessage('E0106', ['「1:食品」「2:非食品」', 'Ｐコード']);
        return;
      }
      // 3：商品非所属の場合
    } else if (imageBelongID === '3') {
      // 「Ｐコード」が入力されている場合、以下のメッセージを表示して処理を終了する。
      if (!PlessViewUtilsSub.isEmpty(this.kymw0C00Model.pCode)) {
        this.dialogService.openAlertGetMessage('E0113', ['所属とＰコード']);
        return;
      }
    }

    // 「撮影予定日」が未入力の場合、以下のメッセージを表示して処理を終了する。
    if (PlessViewUtilsSub.isEmpty(this.kymw0C00Model.photoSchedule)) {
      this.dialogService.openAlertGetMessage('E0110', ['撮影予定日']);
      return;
    }
    // 「撮影場所」が未選択の場合、以下のメッセージを表示して処理を終了する。
    if (PlessViewUtilsSub.isEmpty(this.kymw0C00Model.photoStudioID)) {
      this.dialogService.openAlertGetMessage('E0103', ['撮影場所']);
      return;
    }

    // 	「画像種類」コンボボックスが未指定の場合、以下のメッセージを表示して処理を終了する。
    if (PlessViewUtilsSub.isEmpty(this.kymw0C00Model.imageKind)) {
      this.dialogService.openAlertGetMessage('E0103', ['画像種類']);
      return;
    }

    // 新規か更新か判断
    let isNew = true;
    let msgID = 'Q0104';
    if (this.kymw0C00Model.editMode !== '1') {
      isNew = false;
      msgID = 'Q0105';
    }

    // 編集モードが「登録モード」の場合、画像作成指示リストの行数をチェックし、
    // リストの行数が0件の場合、メッセージを表示して処理を終了する。
    if (isNew && (this.dtg_ImageInstructList.itemsSource == null || this.dtg_ImageInstructList.itemsSource.length <= 0)) {
      this.dialogService.openAlertGetMessage('E0111', ['画像作成指示情報']);
      return;
    }

    // 削除確認メッセージを表示
    this.dialogService.openAlertGetMessage(msgID, ['画像情報管理'], (closeDetail) => {
      // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
      if (closeDetail === PlessAlert.Yes) {
        const vo: UpdateImageInfoModel = this.getUpdateImageInfoVO();
        this.updateImageInfoService.execute(this.kymw0C00Model, vo, (serverData) => {
          this.kymw0C00Model.setUpdateImageInfo(serverData);
          if (this.setKYMW0C00Parameter) {
            const imageInfo = new ImageInfo();
            imageInfo.ImageId = serverData.ImageID;
            const vo = new KYMW0C00OutputModel();
            vo.ImageList = [imageInfo];
            this.setKYMW0C00Parameter(vo);
          }
        });
      }
    });
  }

  /**
   *「使用ページ確認」を呼び出す
   * @param inputVo
   * 使用ページ確認を呼び出すための引数
   *
   */
  public openUsePageCheck(inputVo: KYMW0E00InputModel): void {
    const componentRef = this.dialogService.openModal(KYMW0E00Component);
    const instance = componentRef.componentInstance as KYMW0E00Component;
    instance.parent = this;
    instance.setInterfaceParam(inputVo);
    instance.closeFunction = () => {
      componentRef.close();
    };
    instance.setKYMW0E00Parameter = (outputVO: KYMW0E00OutputModel) => {
      // 処理は何もしない
    };
  }

  /**
   * 新規ボタンイベントリスナー
   * @event
   */
  public eventNew_ClickHandler(event: Event): void {
    if (this.kymw0C00Model.changeAllFlg || this.kymw0C00Model.changeDetailFlg) {
      // 確認メッセージを表示
      this.dialogService.openAlertGetMessage('Q0110', [], (closeDetail) => {
        // 確認結果が「はい」の場合は、画面の遷移処理を実施する。
        if (closeDetail === PlessAlert.Yes) {
          this.eventNew_CLICKConfirmHandler();
        } else {
          if (this.kymw0C00Model.changeAllFlg) {
            document.getElementById('txti_StartOrderCode').focus();
          } else {
            document.getElementById('cmb_ImageType').focus();
          }
        }
      });
    } else {
      this.eventNew_CLICKConfirmHandler();
    }
  }

  /**
   * 新規ボタン確認
   * @event
   */
  public eventNew_CLICKConfirmHandler(): void {
    // インプットパラメータ初期化
    this.inputParam = new KYMW0C00InputModel();

    // 画面クリア処理
    this.kymw0C00Model.clearImageInfoHead();
    this.kymw0C00Model.clearImageInfoDetail();
    this.kymw0C00Model.workReferenceImageDeleteList = new Array<ReferenceImageDeleteList>();
    this.kymw0C00Model.referenceImageDeleteList = new Array<ReferenceImageDeleteList>();

    // 画面活性・非活性設定
    this.kymw0C00Model.endOrderCodeEnabled = false;
    this.kymw0C00Model.endOrderNothingEnabled = true;
    this.kymw0C00Model.pCodeEnabled = true;
    this.kymw0C00Model.imageBelongIdEnabled = true;
    this.kymw0C00Model.imageTypeEnabled = true;

    // 初期処理呼出
    this.ngOnInit();
  }

  /**
   * 出力ボタンイベントリスナー
   * @event
   */
  public eventOutput_ClickHandler(event: Event): void {
    // 所属が商品非所属の場合は出力不可
    if (this.kymw0C00Model.imageBelongID === '3') {
      this.dialogService.openAlertGetMessage('E0164', ['商品非所属の画像情報', '出力']);
      return;
    }

    this.dialogService.openAlertGetMessage('Q0109', [], (closeDetail) => {
      if (closeDetail === PlessAlert.Yes) {
        const imageGroupNo = this.kymw0C00Model.ImageGroupNO;
        this.getSampleOrderingOutputService.execute(this.kymw0C00Model, [imageGroupNo], (serverData) => {
          if (serverData.ErrorFlag === '1') {
            this.dialogService.openAlertGetMessage(serverData.ErrorCode, [serverData.ErrorExp], () => {
              this.download(serverData);
            });
          } else {
            this.download(serverData);
          }
        });
      }
    });
  }

  /**
   * ファイルダウンロード処理
   */
  public download(serverData: any): void {
    // ダウンロードするURL、ファイル名を画面起動のパラメタとして渡すため
    // URL
    const url: string = serverData.FileUrl;
    // ファイル名用 現在日時
    const nowDate = PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss');
    // ファイル名
    const file = 'サンプル発注書・撮影指示書_' + nowDate + '.zip';
    this.fileDownloadConfirmService.show(url, file);
  }

  /**
   * 閉じるボタンクリックイベントリスナ
   * @param event
   */
  public onClickWindowClose(): void {
    // 参照権限の場合はそのまま閉じる
    if (this.kymw0C00Model.funcPermissionViewer) {
      this.closeFunction();
    }

    // 画像情報の編集等が行われたか確認する。
    if (this.kymw0C00Model.changeAllFlg || this.kymw0C00Model.changeDetailFlg) {
      // 確認メッセージを表示
      this.dialogService.openAlertGetMessage('Q0110', [], (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          this.closeFunction();
        }
      });
    } else {
      this.closeFunction();
    }
  }
  
  /**
   * ページ遷移イベント
   */
  canDeactivate(): CanDeactivateType {
    const result = new Subject<boolean>();
    if (this.kymw0C00Model.changeAllFlg || this.kymw0C00Model.changeDetailFlg) {
      // 確認メッセージを表示
      this.dialogService.openAlertGetMessage('Q0110', [], (closeDetail: any) => {
        if (closeDetail === PlessAlert.Yes) {
          result.next(true);
        } else {
          result.next(false);
        }
      });
      return result;
    } else {
      // 画面を終了する
      return true;
    }
  }

  /**
   * @copy jp.co.toppan.pless.coopnet.commons.KYMW04.IKYMW0400#setKYMW0400Parameter()
   */
  public setKYMW0400Parameter(outputVO: KYMW0400OutputModel): void {
    // 『取引先一覧』画面（KYMW0400）を呼び出し、取引先を選択する。
    // サンプル発注先
    if (outputVO.supplierFlg === '0') {
      this.kymw0C00Model.sampleOrderingCode = outputVO.supplierCode;
      this.kymw0C00Model.sampleSupplierNameKanji = outputVO.supplierNameKanji;
      // 画面全項目変更イベント処理の呼び出し
      this.eventHead_CHANGEHandler();
      // 請求先
    } else if (outputVO.supplierFlg === '1') {
      this.kymw0C00Model.billingCode = outputVO.supplierCode;
      this.kymw0C00Model.billingSupplierNameKanji = outputVO.supplierNameKanji;

      // 画面全項目変更イベント処理の呼び出し
      this.eventHead_CHANGEHandler();
    }
  }

  /**
   * 一覧設定用のオブジェクトを画面から取得する
   */
  private getImageInfoObject(): ImageInstructListRowModel {
    if (this.kymw0C00Model.imageName === '') {
      this.kymw0C00Model.imageName = '*********';
    }

    // 画像IDが存在しない場合は一覧イメージID最大のマックス値を取得
    if (this.kymw0C00Model.imageId === '') {
      this.kymw0C00Model.imageId = this.getMaxImageID();
    }

    const returnObject = new ImageInstructListRowModel();
    returnObject.imageID = this.kymw0C00Model.imageId;
    returnObject.imageBelongIDName = this.cmb_ImageBelongID.selectedCodeValueName;
    returnObject.imageName = this.kymw0C00Model.imageName;
    returnObject.imageFileName = this.kymw0C00Model.imageFileName;
    returnObject.status = this.kymw0C00Model.status;
    returnObject.statusName = this.kymw0C00Model.statusName;
    returnObject.imageType = this.cmb_ImageType.selectedCodeValue;
    returnObject.imageTypeName = this.cmb_ImageType.selectedCodeName;
    returnObject.processInstruct = this.kymw0C00Model.processInstruct;
    returnObject.processInstructName = this.cmb_ProcessInstruct.selectedCodeName;
    returnObject.cookingExPublish = PlessViewUtilsSub.booleanTOString(this.kymw0C00Model.cookingExPublish);
    returnObject.cookingDiv = this.cmb_CookingDiv.selectedCodeValue;
    returnObject.cookingName = this.kymw0C00Model.cookingName;
    returnObject.materialName = this.kymw0C00Model.materialName;
    returnObject.eventID = this.cmb_EventID.selectedCodeValue;
    returnObject.photoContentsDiv = this.cmb_PhotoContentsDiv.selectedCodeValue;
    returnObject.remarks = this.kymw0C00Model.remarks;
    returnObject.keyWord = this.kymw0C00Model.keyWord;
    returnObject.textCaption = this.kymw0C00Model.textCaption;
    returnObject.photoInstructContents = this.kymw0C00Model.photoInstructContents;
    returnObject.colorChange = this.kymw0C00Model.colorChange;
    returnObject.multipleCode = this.kymw0C00Model.multipleCode;
    returnObject.sampleNum = this.kymw0C00Model.sampleNum;
    returnObject.promotionFlg = this.kymw0C00Model.promotionFlg;
    returnObject.shooting = this.kymw0C00Model.shooting;
    returnObject.shootingPackageText = this.kymw0C00Model.shootingPackageText;
    returnObject.shootingAngle = this.kymw0C00Model.shootingAngle;
    returnObject.alignment = this.kymw0C00Model.alignment;
    returnObject.alignmentHorizontal = this.kymw0C00Model.alignmentHorizontal;
    returnObject.alignmentVertical = this.kymw0C00Model.alignmentVertical;
    returnObject.vesselPlating = this.kymw0C00Model.vesselPlating;
    returnObject.plating = this.kymw0C00Model.plating;
    returnObject.accompaniments = this.kymw0C00Model.accompaniments;
    returnObject.qtyCookNecessary = this.kymw0C00Model.qtyCookNecessary;
    returnObject.qtyCookNecessaryNum = this.kymw0C00Model.qtyCookNecessaryNum;
    returnObject.qtyCookNecessaryVesselNum = this.kymw0C00Model.qtyCookNecessaryVesselNum;
    returnObject.vesselShapeCookNecessary = this.kymw0C00Model.vesselShapeCookNecessary;
    returnObject.vesselCookNecessary = this.kymw0C00Model.vesselCookNecessary;
    returnObject.photoImageCookNecessary = this.kymw0C00Model.photoImageCookNecessary;
    returnObject.crossSection = this.kymw0C00Model.crossSection;
    returnObject.photoRenditionCookNecessary = this.kymw0C00Model.photoRenditionCookNecessary;
    returnObject.qtyCookUnnecessary = this.kymw0C00Model.qtyCookUnnecessary;
    returnObject.qtyCookUnnecessaryNum = this.kymw0C00Model.qtyCookUnnecessaryNum;
    returnObject.qtyCookUnnecessaryVesselNum = this.kymw0C00Model.qtyCookUnnecessaryVesselNum;
    returnObject.vesselShapeCookUnnecessary = this.kymw0C00Model.vesselShapeCookUnnecessary;
    returnObject.vesselCookUnnecessary = this.kymw0C00Model.vesselCookUnnecessary;
    returnObject.photoImageCookUnnecessary = this.kymw0C00Model.photoImageCookUnnecessary;
    returnObject.photoRenditionCookUnnecessary = this.kymw0C00Model.photoRenditionCookUnnecessary;
    returnObject.cropExistenceType = this.kymw0C00Model.cropExistenceType;
    this.kymw0C00Model.referenceImageList.forEach((element, ind) => {
      returnObject[`referenceImageFileName${ind + 1}`] = element.fileName;
      returnObject[`photoInstructContents${ind + 1}`] = element.photoInstructContents;
      returnObject[`imageSrc${ind + 1}`] = element.src;
      returnObject[`registeredImageFileFlg${ind + 1}`] = element.registeredImageFileFlg;
    });

    return returnObject;
  }

  /**
   * 一覧の最大画像IDに１をプラスして返却する
   */
  private getMaxImageID(): string {
    let maxImageID: number = <number>0;
    for (let i = Number(0); i < this.dtg_ImageInstructList.itemsSource.length; i++) {
      if (Number(this.dtg_ImageInstructList.itemsSource[i].imageID) > maxImageID) {
        maxImageID = Number(this.dtg_ImageInstructList.itemsSource[i].imageID);
      }
    }
    maxImageID = maxImageID + 1;
    return String(maxImageID);
  }

  /**
   * 更新用の情報VOを取得する
   */
  private getUpdateImageInfoVO(): UpdateImageInfoModel {
    const vo: UpdateImageInfoModel = new UpdateImageInfoModel();
    vo.ImageGroupNO = this.kymw0C00Model.ImageGroupNO;
    vo.StartOrderCode = this.kymw0C00Model.startOrderCode;
    if (PlessViewUtilsSub.isEmpty(this.kymw0C00Model.endOrderCode)) {
      vo.EndOrderCode = '9999999';
    } else {
      vo.EndOrderCode = this.kymw0C00Model.endOrderCode;
    }
    vo.EFriendsProduct = this.kymw0C00Model.eFriends;
    vo.ImageBelongID = this.kymw0C00Model.imageBelongID;
    vo.PCode = this.kymw0C00Model.pCode;
    vo.PhotoSchedule = this.kymw0C00Model.photoSchedule.replace('/', '').replace('/', '');
    vo.PhotoStudioID = this.kymw0C00Model.photoStudioID;
    vo.SampleOrderingCode = this.kymw0C00Model.sampleOrderingCode;
    vo.BillingCode = this.kymw0C00Model.billingCode;
    vo.BillingTargetDiv = this.kymw0C00Model.billingTargetDiv;
    vo.Memo = this.kymw0C00Model.memo;
    vo.ImageKind = this.kymw0C00Model.imageKind;
    vo.ReferenceImageDeleteList = this.kymw0C00Model.referenceImageDeleteList;

    for (let i = Number(0); i < this.dtg_ImageInstructList.collectionView.items.length; i++) {
      const row: any = this.dtg_ImageInstructList.collectionView.items[i];

      const detailVO: UpdateImageInfoDetailModel = new UpdateImageInfoDetailModel();
      detailVO.ImageID = row.imageID;
      detailVO.ImageType = PlessViewUtilsSub.nullToBlank(row.imageType);
      detailVO.ProcessInstruct = PlessViewUtilsSub.nullToBlank(row.processInstruct);
      detailVO.CookingExPublish = row.cookingExPublish;
      detailVO.CookingDiv = PlessViewUtilsSub.nullToBlank(row.cookingDiv);
      detailVO.CookingName = PlessViewUtilsSub.nullToBlank(row.cookingName);
      detailVO.MaterialName = PlessViewUtilsSub.nullToBlank(row.materialName);
      detailVO.EventID = PlessViewUtilsSub.nullToBlank(row.eventID);
      detailVO.PhotoContentsDiv = PlessViewUtilsSub.nullToBlank(row.photoContentsDiv);
      detailVO.Remarks = PlessViewUtilsSub.nullToBlank(row.remarks);
      detailVO.KeyWord = PlessViewUtilsSub.nullToBlank(row.keyWord);
      detailVO.TextCaption = PlessViewUtilsSub.nullToBlank(row.textCaption);
      detailVO.PhotoInstructContents = PlessViewUtilsSub.nullToBlank(row.photoInstructContents);

      detailVO.MultipleCode = PlessViewUtilsSub.nullToBlank(row.multipleCode);
      detailVO.SampleNum = PlessViewUtilsSub.nullToBlank(row.sampleNum);
      detailVO.PromotionFlg = row.promotionFlg;
      detailVO.Shooting = PlessViewUtilsSub.nullToBlank(row.shooting);
      detailVO.ShootingPackageText = PlessViewUtilsSub.nullToBlank(row.shootingPackageText);
      detailVO.ShootingAngle = PlessViewUtilsSub.nullToBlank(row.shootingAngle);
      detailVO.Alignment = PlessViewUtilsSub.nullToBlank(row.alignment);
      detailVO.AlignmentHorizontal = PlessViewUtilsSub.nullToBlank(row.alignmentHorizontal);
      detailVO.AlignmentVertical = PlessViewUtilsSub.nullToBlank(row.alignmentVertical);
      detailVO.VesselPlating = PlessViewUtilsSub.nullToBlank(row.vesselPlating);
      detailVO.ColorChange = PlessViewUtilsSub.nullToBlank(row.colorChange);
      detailVO.Plating = PlessViewUtilsSub.nullToBlank(row.plating);
      detailVO.Accompaniments = PlessViewUtilsSub.nullToBlank(row.accompaniments);
      detailVO.QtyCookNecessary = PlessViewUtilsSub.nullToBlank(row.qtyCookNecessary);
      detailVO.QtyCookNecessaryNum = PlessViewUtilsSub.nullToBlank(row.qtyCookNecessaryNum);
      detailVO.QtyCookNecessaryVesselNum = PlessViewUtilsSub.nullToBlank(row.qtyCookNecessaryVesselNum);
      detailVO.VesselShapeCookNecessary = PlessViewUtilsSub.nullToBlank(row.vesselShapeCookNecessary);
      detailVO.VesselCookNecessary = PlessViewUtilsSub.nullToBlank(row.vesselCookNecessary);
      detailVO.PhotoImageCookNecessary = PlessViewUtilsSub.nullToBlank(row.photoImageCookNecessary);
      detailVO.CrossSection = row.crossSection;
      detailVO.PhotoRenditionCookNecessary = PlessViewUtilsSub.nullToBlank(row.photoRenditionCookNecessary);
      detailVO.QtyCookUnnecessary = PlessViewUtilsSub.nullToBlank(row.qtyCookUnnecessary);
      detailVO.QtyCookUnnecessaryNum = PlessViewUtilsSub.nullToBlank(row.qtyCookUnnecessaryNum);
      detailVO.QtyCookUnnecessaryVesselNum = PlessViewUtilsSub.nullToBlank(row.qtyCookUnnecessaryVesselNum);
      detailVO.VesselShapeCookUnnecessary = PlessViewUtilsSub.nullToBlank(row.vesselShapeCookUnnecessary);
      detailVO.VesselCookUnnecessary = PlessViewUtilsSub.nullToBlank(row.vesselCookUnnecessary);
      detailVO.PhotoImageCookUnnecessary = PlessViewUtilsSub.nullToBlank(row.photoImageCookUnnecessary);
      detailVO.PhotoRenditionCookUnnecessary = row.photoRenditionCookUnnecessary;
      detailVO.CropExistenceType = PlessViewUtilsSub.nullToBlank(row.cropExistenceType);

      detailVO.ReferenceImageFileName1 = PlessViewUtilsSub.nullToBlank(row.referenceImageFileName1);
      detailVO.ReferenceImageFileName2 = PlessViewUtilsSub.nullToBlank(row.referenceImageFileName2);
      detailVO.ReferenceImageFileName3 = PlessViewUtilsSub.nullToBlank(row.referenceImageFileName3);
      detailVO.PhotoInstructContents1 = PlessViewUtilsSub.nullToBlank(row.photoInstructContents1);
      detailVO.PhotoInstructContents2 = PlessViewUtilsSub.nullToBlank(row.photoInstructContents2);
      detailVO.PhotoInstructContents3 = PlessViewUtilsSub.nullToBlank(row.photoInstructContents3);

      if (row.editStatus === '新規') {
        detailVO.ImageID = '';
        vo.ImageInfoInsertList.push(detailVO);
      } else if (row.editStatus === '削除') {
        vo.ImageInfoDeleteList.push(detailVO);
        if (!PlessViewUtilsSub.isEmpty(detailVO.ReferenceImageFileName1)) {
          vo.ReferenceImageDeleteList.push({
            ImageID: detailVO.ImageID,
            ReferenceImageFileName: detailVO.ReferenceImageFileName1
          });
        }
        if (!PlessViewUtilsSub.isEmpty(detailVO.ReferenceImageFileName2)) {
          vo.ReferenceImageDeleteList.push({
            ImageID: detailVO.ImageID,
            ReferenceImageFileName: detailVO.ReferenceImageFileName2
          });
        }
        if (!PlessViewUtilsSub.isEmpty(detailVO.ReferenceImageFileName3)) {
          vo.ReferenceImageDeleteList.push({
            ImageID: detailVO.ImageID,
            ReferenceImageFileName: detailVO.ReferenceImageFileName3
          });
        }
      } else {
        vo.ImageInfoUpdateList.push(detailVO);
      }
    }

    return vo;
  }

  /**
   * 超過する画像種別が１つでも存在する場合TRUEを返却する
   */
  private isOverImageType(imageType: string): boolean {
    let count: number = <number>0;
    for (let i = Number(0); i < this.dtg_ImageInstructList.itemsSource.length; i++) {
      if (this.dtg_ImageInstructList.itemsSource[i].imageType === imageType) {
        count++;
      }
    }

    // 上限件数比較
    return (count >= this.getImageTypeLimit(imageType)) ? true : false;
  }

  /**
   * 画像種別上限件数を取得する
   */
  private getImageTypeLimit(imageType: string): number {
    for (let i = Number(0); i < this.kymw0C00Model.imageTypeList.length; i++) {
      if (PlessViewUtilsSub.trim(this.kymw0C00Model.imageTypeList[i].Code) === imageType) {
        return this.kymw0C00Model.imageTypeList[i].Limit;
      }
    }
    return 0;
  }

  /**
   * 選択されたイメージのデータグリッドインデックスを返却する
   */
  private getSelectedImageIDIndex(): number {
    for (let i = Number(0); i < this.dtg_ImageInstructList.collectionView.items.length; i++) {
      if (this.dtg_ImageInstructList.collectionView.items[i].imageID === this.kymw0C00Model.imageId) {
        return i;
      }
    }
    return -1;
  }

  /**
   * 指定された画像IDの画像情報を返却する
   * @param targetImageId 取得対象の画像ID
   * @return 画像情報
   */
  public getImageInfo(targetImageId: string): any {
    return this.dtg_ImageInstructList.rows.filter(row => (row as any).imageID === targetImageId);
  }

  /**
   * 指定された受注コードで開始受注コードと使用開始配達企画回(翌週)を更新する。
   * また、自動セットされた場合に使用開始配達企画回(翌週)のバインド変数に
   * 値がセットされないため明示的にセットする
   *
   * @private
   * @param {string} orderCode
   * @memberof KYMW0C00Component
   */

  //   this.kymw0C00Model.startOrderDelivCatalogID = this.txti_StartOrderCode.selectedCatalogID;
  // }

  /**
   * 指定された受注コードで終了受注コードと使用終了配達企画回(翌週)を更新する。
   * また、自動セットされた場合に終了受注コードと使用終了配達企画回(翌週)のバインド変数に
   * 値がセットされないため明示的にセットする
   *
   * @private
   * @param {string} orderCode
   * @memberof KYMW0C00Component
   */
  private setEndOrderCode(orderCode: string) {
    this.kymw0C00Model.endOrderCode = orderCode;
  }

  /**
   * 参考資料の撮影指示内容チェンジイベントリスナ
   */
  public eventReferenceImageContents_CHANGEHandler(): void {
    this.eventDetail_CHANGEHandler();
  }

  /**
   * アイコン画像設定メソッド
   * 再表示時に使用
   * @param imageSrc 参考資料ファイル名（XXX.pdf,XXX.xlsxなど）
   */
  public getExtensionImage(imageSrc): string {
    const extension = PlessViewUtilsSub.getExtension(imageSrc);
    if (this.excelExtensions.includes(extension)) {
      return "./assets/icons/KYMW0C/ExcelLogo.png";
    } else if (extension == "pdf") {
      return "./assets/icons/KYMW0C/pdfLogo.png";
    } else {
      // Excel、PDF以外はそのまま返す
      return imageSrc;
    }
  }
}
